/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreateUserInput = {
  id?: string | null,
  username: string,
  email: string,
  firstName: string,
  lastName: string,
  displayName: string,
  profilePictureUrl?: string | null,
  role: UserRole,
  profileCompleted: boolean,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum UserRole {
  PLAYER = "PLAYER",
  ADMIN = "ADMIN",
}


export type ModelUserConditionInput = {
  username?: ModelStringInput | null,
  email?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  displayName?: ModelStringInput | null,
  profilePictureUrl?: ModelStringInput | null,
  role?: ModelUserRoleInput | null,
  profileCompleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserConditionInput | null > | null,
  or?: Array< ModelUserConditionInput | null > | null,
  not?: ModelUserConditionInput | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelUserRoleInput = {
  eq?: UserRole | null,
  ne?: UserRole | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type User = {
  __typename: "User",
  id: string,
  username: string,
  email: string,
  firstName: string,
  lastName: string,
  displayName: string,
  profilePictureUrl?: string | null,
  role: UserRole,
  profileCompleted: boolean,
  playerConstructs?: ModelPlayerConstructConnection | null,
  topCutResults?: ModelEventTopCutResultConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelPlayerConstructConnection = {
  __typename: "ModelPlayerConstructConnection",
  items:  Array<PlayerConstruct | null >,
  nextToken?: string | null,
};

export type PlayerConstruct = {
  __typename: "PlayerConstruct",
  id: string,
  name: string,
  normalizedName?: string | null,
  totalEvents: number,
  totalPoints: number,
  totalWins: number,
  totalLosses: number,
  totalDraws: number,
  bestRank?: number | null,
  averageRank?: number | null,
  leagueStats?: ModelLeaguePlayerStatsConnection | null,
  eventResults?: ModelEventPlayerResultConnection | null,
  topCutResults?: ModelEventTopCutResultConnection | null,
  userId?: string | null,
  user?: User | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelLeaguePlayerStatsConnection = {
  __typename: "ModelLeaguePlayerStatsConnection",
  items:  Array<LeaguePlayerStats | null >,
  nextToken?: string | null,
};

export type LeaguePlayerStats = {
  __typename: "LeaguePlayerStats",
  id: string,
  leagueId: string,
  league?: League | null,
  playerConstructId: string,
  playerConstruct?: PlayerConstruct | null,
  totalPoints: number,
  totalEvents: number,
  totalWins: number,
  totalLosses: number,
  totalDraws: number,
  bestRank?: number | null,
  averageRank?: number | null,
  averageFinishPercentile?: number | null,
  currentRank?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type League = {
  __typename: "League",
  id: string,
  name: string,
  description?: string | null,
  game?: string | null,
  format: string,
  participationPoints?: number | null,
  winPoints?: number | null,
  drawPoints?: number | null,
  lossPoints?: number | null,
  top8FirstPoints?: number | null,
  top8SecondPoints?: number | null,
  top8ThirdFourthPoints?: number | null,
  top8FifthEighthPoints?: number | null,
  commanderFirstPoints?: number | null,
  commanderSecondPoints?: number | null,
  commanderThirdPoints?: number | null,
  commanderFourthPoints?: number | null,
  premiumMultiplier?: number | null,
  startDate: string,
  endDate?: string | null,
  isActive: boolean,
  maxParticipants?: number | null,
  playerStats?: ModelLeaguePlayerStatsConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelEventPlayerResultConnection = {
  __typename: "ModelEventPlayerResultConnection",
  items:  Array<EventPlayerResult | null >,
  nextToken?: string | null,
};

export type EventPlayerResult = {
  __typename: "EventPlayerResult",
  id: string,
  eventId: string,
  event?: Event | null,
  playerConstructId: string,
  playerConstruct?: PlayerConstruct | null,
  rank: number,
  points: number,
  omw: number,
  gw: number,
  ogw: number,
  wins: number,
  losses: number,
  draws: number,
  createdAt: string,
  updatedAt: string,
};

export type Event = {
  __typename: "Event",
  id: string,
  name: string,
  description?: string | null,
  leagueId: string,
  date: string,
  location: string,
  format: string,
  maxRounds: number,
  fieldSize?: number | null,
  isCompleted: boolean,
  isPremium?: boolean | null,
  hasTopCut?: boolean | null,
  playerResults?: ModelEventPlayerResultConnection | null,
  topCutResults?: ModelEventTopCutResultConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelEventTopCutResultConnection = {
  __typename: "ModelEventTopCutResultConnection",
  items:  Array<EventTopCutResult | null >,
  nextToken?: string | null,
};

export type EventTopCutResult = {
  __typename: "EventTopCutResult",
  id: string,
  eventId: string,
  event?: Event | null,
  userId?: string | null,
  user?: User | null,
  playerConstructId?: string | null,
  playerConstruct?: PlayerConstruct | null,
  rank: number,
  bonusPoints: number,
  createdAt: string,
  updatedAt: string,
};

export type UpdateUserInput = {
  id: string,
  username?: string | null,
  email?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  displayName?: string | null,
  profilePictureUrl?: string | null,
  role?: UserRole | null,
  profileCompleted?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteUserInput = {
  id: string,
};

export type CreatePlayerConstructInput = {
  id?: string | null,
  name: string,
  normalizedName?: string | null,
  totalEvents: number,
  totalPoints: number,
  totalWins: number,
  totalLosses: number,
  totalDraws: number,
  bestRank?: number | null,
  averageRank?: number | null,
  userId?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelPlayerConstructConditionInput = {
  name?: ModelStringInput | null,
  normalizedName?: ModelStringInput | null,
  totalEvents?: ModelIntInput | null,
  totalPoints?: ModelIntInput | null,
  totalWins?: ModelIntInput | null,
  totalLosses?: ModelIntInput | null,
  totalDraws?: ModelIntInput | null,
  bestRank?: ModelIntInput | null,
  averageRank?: ModelFloatInput | null,
  userId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPlayerConstructConditionInput | null > | null,
  or?: Array< ModelPlayerConstructConditionInput | null > | null,
  not?: ModelPlayerConstructConditionInput | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type UpdatePlayerConstructInput = {
  id: string,
  name?: string | null,
  normalizedName?: string | null,
  totalEvents?: number | null,
  totalPoints?: number | null,
  totalWins?: number | null,
  totalLosses?: number | null,
  totalDraws?: number | null,
  bestRank?: number | null,
  averageRank?: number | null,
  userId?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeletePlayerConstructInput = {
  id: string,
};

export type CreateLeaguePlayerStatsInput = {
  id?: string | null,
  leagueId: string,
  playerConstructId: string,
  totalPoints: number,
  totalEvents: number,
  totalWins: number,
  totalLosses: number,
  totalDraws: number,
  bestRank?: number | null,
  averageRank?: number | null,
  averageFinishPercentile?: number | null,
  currentRank?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelLeaguePlayerStatsConditionInput = {
  leagueId?: ModelIDInput | null,
  playerConstructId?: ModelIDInput | null,
  totalPoints?: ModelIntInput | null,
  totalEvents?: ModelIntInput | null,
  totalWins?: ModelIntInput | null,
  totalLosses?: ModelIntInput | null,
  totalDraws?: ModelIntInput | null,
  bestRank?: ModelIntInput | null,
  averageRank?: ModelFloatInput | null,
  averageFinishPercentile?: ModelFloatInput | null,
  currentRank?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLeaguePlayerStatsConditionInput | null > | null,
  or?: Array< ModelLeaguePlayerStatsConditionInput | null > | null,
  not?: ModelLeaguePlayerStatsConditionInput | null,
};

export type UpdateLeaguePlayerStatsInput = {
  id: string,
  leagueId?: string | null,
  playerConstructId?: string | null,
  totalPoints?: number | null,
  totalEvents?: number | null,
  totalWins?: number | null,
  totalLosses?: number | null,
  totalDraws?: number | null,
  bestRank?: number | null,
  averageRank?: number | null,
  averageFinishPercentile?: number | null,
  currentRank?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteLeaguePlayerStatsInput = {
  id: string,
};

export type CreateLeaguePointAdjustmentInput = {
  id?: string | null,
  leagueId: string,
  userId?: string | null,
  playerConstructId?: string | null,
  playerName: string,
  points: number,
  reason: string,
  createdBy: string,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelLeaguePointAdjustmentConditionInput = {
  leagueId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  playerConstructId?: ModelIDInput | null,
  playerName?: ModelStringInput | null,
  points?: ModelIntInput | null,
  reason?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLeaguePointAdjustmentConditionInput | null > | null,
  or?: Array< ModelLeaguePointAdjustmentConditionInput | null > | null,
  not?: ModelLeaguePointAdjustmentConditionInput | null,
};

export type LeaguePointAdjustment = {
  __typename: "LeaguePointAdjustment",
  id: string,
  leagueId: string,
  userId?: string | null,
  playerConstructId?: string | null,
  playerName: string,
  points: number,
  reason: string,
  createdBy: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateLeaguePointAdjustmentInput = {
  id: string,
  leagueId?: string | null,
  userId?: string | null,
  playerConstructId?: string | null,
  playerName?: string | null,
  points?: number | null,
  reason?: string | null,
  createdBy?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteLeaguePointAdjustmentInput = {
  id: string,
};

export type CreateEventPlayerResultInput = {
  id?: string | null,
  eventId: string,
  playerConstructId: string,
  rank: number,
  points: number,
  omw: number,
  gw: number,
  ogw: number,
  wins: number,
  losses: number,
  draws: number,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelEventPlayerResultConditionInput = {
  eventId?: ModelIDInput | null,
  playerConstructId?: ModelIDInput | null,
  rank?: ModelIntInput | null,
  points?: ModelIntInput | null,
  omw?: ModelFloatInput | null,
  gw?: ModelFloatInput | null,
  ogw?: ModelFloatInput | null,
  wins?: ModelIntInput | null,
  losses?: ModelIntInput | null,
  draws?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelEventPlayerResultConditionInput | null > | null,
  or?: Array< ModelEventPlayerResultConditionInput | null > | null,
  not?: ModelEventPlayerResultConditionInput | null,
};

export type UpdateEventPlayerResultInput = {
  id: string,
  eventId?: string | null,
  playerConstructId?: string | null,
  rank?: number | null,
  points?: number | null,
  omw?: number | null,
  gw?: number | null,
  ogw?: number | null,
  wins?: number | null,
  losses?: number | null,
  draws?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteEventPlayerResultInput = {
  id: string,
};

export type CreateLeagueInput = {
  id?: string | null,
  name: string,
  description?: string | null,
  game?: string | null,
  format: string,
  participationPoints?: number | null,
  winPoints?: number | null,
  drawPoints?: number | null,
  lossPoints?: number | null,
  top8FirstPoints?: number | null,
  top8SecondPoints?: number | null,
  top8ThirdFourthPoints?: number | null,
  top8FifthEighthPoints?: number | null,
  commanderFirstPoints?: number | null,
  commanderSecondPoints?: number | null,
  commanderThirdPoints?: number | null,
  commanderFourthPoints?: number | null,
  premiumMultiplier?: number | null,
  startDate: string,
  endDate?: string | null,
  isActive: boolean,
  maxParticipants?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelLeagueConditionInput = {
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  game?: ModelStringInput | null,
  format?: ModelStringInput | null,
  participationPoints?: ModelIntInput | null,
  winPoints?: ModelIntInput | null,
  drawPoints?: ModelIntInput | null,
  lossPoints?: ModelIntInput | null,
  top8FirstPoints?: ModelIntInput | null,
  top8SecondPoints?: ModelIntInput | null,
  top8ThirdFourthPoints?: ModelIntInput | null,
  top8FifthEighthPoints?: ModelIntInput | null,
  commanderFirstPoints?: ModelIntInput | null,
  commanderSecondPoints?: ModelIntInput | null,
  commanderThirdPoints?: ModelIntInput | null,
  commanderFourthPoints?: ModelIntInput | null,
  premiumMultiplier?: ModelIntInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  isActive?: ModelBooleanInput | null,
  maxParticipants?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLeagueConditionInput | null > | null,
  or?: Array< ModelLeagueConditionInput | null > | null,
  not?: ModelLeagueConditionInput | null,
};

export type UpdateLeagueInput = {
  id: string,
  name?: string | null,
  description?: string | null,
  game?: string | null,
  format?: string | null,
  participationPoints?: number | null,
  winPoints?: number | null,
  drawPoints?: number | null,
  lossPoints?: number | null,
  top8FirstPoints?: number | null,
  top8SecondPoints?: number | null,
  top8ThirdFourthPoints?: number | null,
  top8FifthEighthPoints?: number | null,
  commanderFirstPoints?: number | null,
  commanderSecondPoints?: number | null,
  commanderThirdPoints?: number | null,
  commanderFourthPoints?: number | null,
  premiumMultiplier?: number | null,
  startDate?: string | null,
  endDate?: string | null,
  isActive?: boolean | null,
  maxParticipants?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteLeagueInput = {
  id: string,
};

export type CreateEventInput = {
  id?: string | null,
  name: string,
  description?: string | null,
  leagueId: string,
  date: string,
  location: string,
  format: string,
  maxRounds: number,
  fieldSize?: number | null,
  isCompleted: boolean,
  isPremium?: boolean | null,
  hasTopCut?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelEventConditionInput = {
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  leagueId?: ModelIDInput | null,
  date?: ModelStringInput | null,
  location?: ModelStringInput | null,
  format?: ModelStringInput | null,
  maxRounds?: ModelIntInput | null,
  fieldSize?: ModelIntInput | null,
  isCompleted?: ModelBooleanInput | null,
  isPremium?: ModelBooleanInput | null,
  hasTopCut?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelEventConditionInput | null > | null,
  or?: Array< ModelEventConditionInput | null > | null,
  not?: ModelEventConditionInput | null,
};

export type UpdateEventInput = {
  id: string,
  name?: string | null,
  description?: string | null,
  leagueId?: string | null,
  date?: string | null,
  location?: string | null,
  format?: string | null,
  maxRounds?: number | null,
  fieldSize?: number | null,
  isCompleted?: boolean | null,
  isPremium?: boolean | null,
  hasTopCut?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteEventInput = {
  id: string,
};

export type CreateEventParticipantInput = {
  id?: string | null,
  eventId: string,
  userId?: string | null,
  playerConstructId?: string | null,
  commanderCategory?: CommanderCategory | null,
  registrationDate: string,
  status: ParticipantStatus,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum CommanderCategory {
  CASUAL = "CASUAL",
  OPTIMIZED = "OPTIMIZED",
  COMPETITIVE = "COMPETITIVE",
}


export enum ParticipantStatus {
  REGISTERED = "REGISTERED",
  CHECKED_IN = "CHECKED_IN",
  DROPPED = "DROPPED",
}


export type ModelEventParticipantConditionInput = {
  eventId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  playerConstructId?: ModelIDInput | null,
  commanderCategory?: ModelCommanderCategoryInput | null,
  registrationDate?: ModelStringInput | null,
  status?: ModelParticipantStatusInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelEventParticipantConditionInput | null > | null,
  or?: Array< ModelEventParticipantConditionInput | null > | null,
  not?: ModelEventParticipantConditionInput | null,
};

export type ModelCommanderCategoryInput = {
  eq?: CommanderCategory | null,
  ne?: CommanderCategory | null,
};

export type ModelParticipantStatusInput = {
  eq?: ParticipantStatus | null,
  ne?: ParticipantStatus | null,
};

export type EventParticipant = {
  __typename: "EventParticipant",
  id: string,
  eventId: string,
  userId?: string | null,
  playerConstructId?: string | null,
  commanderCategory?: CommanderCategory | null,
  registrationDate: string,
  status: ParticipantStatus,
  createdAt: string,
  updatedAt: string,
};

export type UpdateEventParticipantInput = {
  id: string,
  eventId?: string | null,
  userId?: string | null,
  playerConstructId?: string | null,
  commanderCategory?: CommanderCategory | null,
  registrationDate?: string | null,
  status?: ParticipantStatus | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteEventParticipantInput = {
  id: string,
};

export type CreateEventStandingInput = {
  id?: string | null,
  eventId: string,
  userId: string,
  rank: number,
  points: number,
  omw: number,
  gw: number,
  ogw: number,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelEventStandingConditionInput = {
  eventId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  rank?: ModelIntInput | null,
  points?: ModelIntInput | null,
  omw?: ModelFloatInput | null,
  gw?: ModelFloatInput | null,
  ogw?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelEventStandingConditionInput | null > | null,
  or?: Array< ModelEventStandingConditionInput | null > | null,
  not?: ModelEventStandingConditionInput | null,
};

export type EventStanding = {
  __typename: "EventStanding",
  id: string,
  eventId: string,
  userId: string,
  rank: number,
  points: number,
  omw: number,
  gw: number,
  ogw: number,
  createdAt: string,
  updatedAt: string,
};

export type UpdateEventStandingInput = {
  id: string,
  eventId?: string | null,
  userId?: string | null,
  rank?: number | null,
  points?: number | null,
  omw?: number | null,
  gw?: number | null,
  ogw?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteEventStandingInput = {
  id: string,
};

export type CreateMatchInput = {
  id?: string | null,
  eventId: string,
  player1Id: string,
  player2Id: string,
  round: number,
  player1Result: MatchResult,
  player2Result: MatchResult,
  completedAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum MatchResult {
  WIN = "WIN",
  LOSS = "LOSS",
  DRAW = "DRAW",
}


export type ModelMatchConditionInput = {
  eventId?: ModelIDInput | null,
  player1Id?: ModelIDInput | null,
  player2Id?: ModelIDInput | null,
  round?: ModelIntInput | null,
  player1Result?: ModelMatchResultInput | null,
  player2Result?: ModelMatchResultInput | null,
  completedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelMatchConditionInput | null > | null,
  or?: Array< ModelMatchConditionInput | null > | null,
  not?: ModelMatchConditionInput | null,
};

export type ModelMatchResultInput = {
  eq?: MatchResult | null,
  ne?: MatchResult | null,
};

export type Match = {
  __typename: "Match",
  id: string,
  eventId: string,
  player1Id: string,
  player2Id: string,
  round: number,
  player1Result: MatchResult,
  player2Result: MatchResult,
  completedAt?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateMatchInput = {
  id: string,
  eventId?: string | null,
  player1Id?: string | null,
  player2Id?: string | null,
  round?: number | null,
  player1Result?: MatchResult | null,
  player2Result?: MatchResult | null,
  completedAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteMatchInput = {
  id: string,
};

export type CreateCommanderRoundInput = {
  id?: string | null,
  eventId: string,
  roundNumber: number,
  status: CommanderRoundStatus,
  publishedAt?: string | null,
  completedAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum CommanderRoundStatus {
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
  COMPLETED = "COMPLETED",
}


export type ModelCommanderRoundConditionInput = {
  eventId?: ModelIDInput | null,
  roundNumber?: ModelIntInput | null,
  status?: ModelCommanderRoundStatusInput | null,
  publishedAt?: ModelStringInput | null,
  completedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCommanderRoundConditionInput | null > | null,
  or?: Array< ModelCommanderRoundConditionInput | null > | null,
  not?: ModelCommanderRoundConditionInput | null,
};

export type ModelCommanderRoundStatusInput = {
  eq?: CommanderRoundStatus | null,
  ne?: CommanderRoundStatus | null,
};

export type CommanderRound = {
  __typename: "CommanderRound",
  id: string,
  eventId: string,
  roundNumber: number,
  status: CommanderRoundStatus,
  publishedAt?: string | null,
  completedAt?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateCommanderRoundInput = {
  id: string,
  eventId?: string | null,
  roundNumber?: number | null,
  status?: CommanderRoundStatus | null,
  publishedAt?: string | null,
  completedAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteCommanderRoundInput = {
  id: string,
};

export type CreateCommanderPodInput = {
  id?: string | null,
  eventId: string,
  roundId: string,
  roundNumber: number,
  podNumber: number,
  category: CommanderCategory,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelCommanderPodConditionInput = {
  eventId?: ModelIDInput | null,
  roundId?: ModelIDInput | null,
  roundNumber?: ModelIntInput | null,
  podNumber?: ModelIntInput | null,
  category?: ModelCommanderCategoryInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCommanderPodConditionInput | null > | null,
  or?: Array< ModelCommanderPodConditionInput | null > | null,
  not?: ModelCommanderPodConditionInput | null,
};

export type CommanderPod = {
  __typename: "CommanderPod",
  id: string,
  eventId: string,
  roundId: string,
  roundNumber: number,
  podNumber: number,
  category: CommanderCategory,
  createdAt: string,
  updatedAt: string,
};

export type UpdateCommanderPodInput = {
  id: string,
  eventId?: string | null,
  roundId?: string | null,
  roundNumber?: number | null,
  podNumber?: number | null,
  category?: CommanderCategory | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteCommanderPodInput = {
  id: string,
};

export type CreateCommanderPodPlayerInput = {
  id?: string | null,
  eventId: string,
  roundId: string,
  podId: string,
  roundNumber: number,
  userId?: string | null,
  playerConstructId?: string | null,
  registeredCategory: CommanderCategory,
  placement?: number | null,
  points?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelCommanderPodPlayerConditionInput = {
  eventId?: ModelIDInput | null,
  roundId?: ModelIDInput | null,
  podId?: ModelIDInput | null,
  roundNumber?: ModelIntInput | null,
  userId?: ModelIDInput | null,
  playerConstructId?: ModelIDInput | null,
  registeredCategory?: ModelCommanderCategoryInput | null,
  placement?: ModelIntInput | null,
  points?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCommanderPodPlayerConditionInput | null > | null,
  or?: Array< ModelCommanderPodPlayerConditionInput | null > | null,
  not?: ModelCommanderPodPlayerConditionInput | null,
};

export type CommanderPodPlayer = {
  __typename: "CommanderPodPlayer",
  id: string,
  eventId: string,
  roundId: string,
  podId: string,
  roundNumber: number,
  userId?: string | null,
  playerConstructId?: string | null,
  registeredCategory: CommanderCategory,
  placement?: number | null,
  points?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateCommanderPodPlayerInput = {
  id: string,
  eventId?: string | null,
  roundId?: string | null,
  podId?: string | null,
  roundNumber?: number | null,
  userId?: string | null,
  playerConstructId?: string | null,
  registeredCategory?: CommanderCategory | null,
  placement?: number | null,
  points?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteCommanderPodPlayerInput = {
  id: string,
};

export type CreateEventTopCutResultInput = {
  id?: string | null,
  eventId: string,
  userId?: string | null,
  playerConstructId?: string | null,
  rank: number,
  bonusPoints: number,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelEventTopCutResultConditionInput = {
  eventId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  playerConstructId?: ModelIDInput | null,
  rank?: ModelIntInput | null,
  bonusPoints?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelEventTopCutResultConditionInput | null > | null,
  or?: Array< ModelEventTopCutResultConditionInput | null > | null,
  not?: ModelEventTopCutResultConditionInput | null,
};

export type UpdateEventTopCutResultInput = {
  id: string,
  eventId?: string | null,
  userId?: string | null,
  playerConstructId?: string | null,
  rank?: number | null,
  bonusPoints?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteEventTopCutResultInput = {
  id: string,
};

export type ModelUserFilterInput = {
  id?: ModelIDInput | null,
  username?: ModelStringInput | null,
  email?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  displayName?: ModelStringInput | null,
  profilePictureUrl?: ModelStringInput | null,
  role?: ModelUserRoleInput | null,
  profileCompleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserFilterInput | null > | null,
  or?: Array< ModelUserFilterInput | null > | null,
  not?: ModelUserFilterInput | null,
};

export type ModelUserConnection = {
  __typename: "ModelUserConnection",
  items:  Array<User | null >,
  nextToken?: string | null,
};

export type ModelPlayerConstructFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  normalizedName?: ModelStringInput | null,
  totalEvents?: ModelIntInput | null,
  totalPoints?: ModelIntInput | null,
  totalWins?: ModelIntInput | null,
  totalLosses?: ModelIntInput | null,
  totalDraws?: ModelIntInput | null,
  bestRank?: ModelIntInput | null,
  averageRank?: ModelFloatInput | null,
  userId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPlayerConstructFilterInput | null > | null,
  or?: Array< ModelPlayerConstructFilterInput | null > | null,
  not?: ModelPlayerConstructFilterInput | null,
};

export type ModelLeaguePlayerStatsFilterInput = {
  id?: ModelIDInput | null,
  leagueId?: ModelIDInput | null,
  playerConstructId?: ModelIDInput | null,
  totalPoints?: ModelIntInput | null,
  totalEvents?: ModelIntInput | null,
  totalWins?: ModelIntInput | null,
  totalLosses?: ModelIntInput | null,
  totalDraws?: ModelIntInput | null,
  bestRank?: ModelIntInput | null,
  averageRank?: ModelFloatInput | null,
  averageFinishPercentile?: ModelFloatInput | null,
  currentRank?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLeaguePlayerStatsFilterInput | null > | null,
  or?: Array< ModelLeaguePlayerStatsFilterInput | null > | null,
  not?: ModelLeaguePlayerStatsFilterInput | null,
};

export type ModelLeaguePointAdjustmentFilterInput = {
  id?: ModelIDInput | null,
  leagueId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  playerConstructId?: ModelIDInput | null,
  playerName?: ModelStringInput | null,
  points?: ModelIntInput | null,
  reason?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLeaguePointAdjustmentFilterInput | null > | null,
  or?: Array< ModelLeaguePointAdjustmentFilterInput | null > | null,
  not?: ModelLeaguePointAdjustmentFilterInput | null,
};

export type ModelLeaguePointAdjustmentConnection = {
  __typename: "ModelLeaguePointAdjustmentConnection",
  items:  Array<LeaguePointAdjustment | null >,
  nextToken?: string | null,
};

export type ModelEventPlayerResultFilterInput = {
  id?: ModelIDInput | null,
  eventId?: ModelIDInput | null,
  playerConstructId?: ModelIDInput | null,
  rank?: ModelIntInput | null,
  points?: ModelIntInput | null,
  omw?: ModelFloatInput | null,
  gw?: ModelFloatInput | null,
  ogw?: ModelFloatInput | null,
  wins?: ModelIntInput | null,
  losses?: ModelIntInput | null,
  draws?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelEventPlayerResultFilterInput | null > | null,
  or?: Array< ModelEventPlayerResultFilterInput | null > | null,
  not?: ModelEventPlayerResultFilterInput | null,
};

export type ModelLeagueFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  game?: ModelStringInput | null,
  format?: ModelStringInput | null,
  participationPoints?: ModelIntInput | null,
  winPoints?: ModelIntInput | null,
  drawPoints?: ModelIntInput | null,
  lossPoints?: ModelIntInput | null,
  top8FirstPoints?: ModelIntInput | null,
  top8SecondPoints?: ModelIntInput | null,
  top8ThirdFourthPoints?: ModelIntInput | null,
  top8FifthEighthPoints?: ModelIntInput | null,
  commanderFirstPoints?: ModelIntInput | null,
  commanderSecondPoints?: ModelIntInput | null,
  commanderThirdPoints?: ModelIntInput | null,
  commanderFourthPoints?: ModelIntInput | null,
  premiumMultiplier?: ModelIntInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  isActive?: ModelBooleanInput | null,
  maxParticipants?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLeagueFilterInput | null > | null,
  or?: Array< ModelLeagueFilterInput | null > | null,
  not?: ModelLeagueFilterInput | null,
};

export type ModelLeagueConnection = {
  __typename: "ModelLeagueConnection",
  items:  Array<League | null >,
  nextToken?: string | null,
};

export type ModelEventFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  leagueId?: ModelIDInput | null,
  date?: ModelStringInput | null,
  location?: ModelStringInput | null,
  format?: ModelStringInput | null,
  maxRounds?: ModelIntInput | null,
  fieldSize?: ModelIntInput | null,
  isCompleted?: ModelBooleanInput | null,
  isPremium?: ModelBooleanInput | null,
  hasTopCut?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelEventFilterInput | null > | null,
  or?: Array< ModelEventFilterInput | null > | null,
  not?: ModelEventFilterInput | null,
};

export type ModelEventConnection = {
  __typename: "ModelEventConnection",
  items:  Array<Event | null >,
  nextToken?: string | null,
};

export type ModelEventParticipantFilterInput = {
  id?: ModelIDInput | null,
  eventId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  playerConstructId?: ModelIDInput | null,
  commanderCategory?: ModelCommanderCategoryInput | null,
  registrationDate?: ModelStringInput | null,
  status?: ModelParticipantStatusInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelEventParticipantFilterInput | null > | null,
  or?: Array< ModelEventParticipantFilterInput | null > | null,
  not?: ModelEventParticipantFilterInput | null,
};

export type ModelEventParticipantConnection = {
  __typename: "ModelEventParticipantConnection",
  items:  Array<EventParticipant | null >,
  nextToken?: string | null,
};

export type ModelEventStandingFilterInput = {
  id?: ModelIDInput | null,
  eventId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  rank?: ModelIntInput | null,
  points?: ModelIntInput | null,
  omw?: ModelFloatInput | null,
  gw?: ModelFloatInput | null,
  ogw?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelEventStandingFilterInput | null > | null,
  or?: Array< ModelEventStandingFilterInput | null > | null,
  not?: ModelEventStandingFilterInput | null,
};

export type ModelEventStandingConnection = {
  __typename: "ModelEventStandingConnection",
  items:  Array<EventStanding | null >,
  nextToken?: string | null,
};

export type ModelMatchFilterInput = {
  id?: ModelIDInput | null,
  eventId?: ModelIDInput | null,
  player1Id?: ModelIDInput | null,
  player2Id?: ModelIDInput | null,
  round?: ModelIntInput | null,
  player1Result?: ModelMatchResultInput | null,
  player2Result?: ModelMatchResultInput | null,
  completedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelMatchFilterInput | null > | null,
  or?: Array< ModelMatchFilterInput | null > | null,
  not?: ModelMatchFilterInput | null,
};

export type ModelMatchConnection = {
  __typename: "ModelMatchConnection",
  items:  Array<Match | null >,
  nextToken?: string | null,
};

export type ModelCommanderRoundFilterInput = {
  id?: ModelIDInput | null,
  eventId?: ModelIDInput | null,
  roundNumber?: ModelIntInput | null,
  status?: ModelCommanderRoundStatusInput | null,
  publishedAt?: ModelStringInput | null,
  completedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCommanderRoundFilterInput | null > | null,
  or?: Array< ModelCommanderRoundFilterInput | null > | null,
  not?: ModelCommanderRoundFilterInput | null,
};

export type ModelCommanderRoundConnection = {
  __typename: "ModelCommanderRoundConnection",
  items:  Array<CommanderRound | null >,
  nextToken?: string | null,
};

export type ModelCommanderPodFilterInput = {
  id?: ModelIDInput | null,
  eventId?: ModelIDInput | null,
  roundId?: ModelIDInput | null,
  roundNumber?: ModelIntInput | null,
  podNumber?: ModelIntInput | null,
  category?: ModelCommanderCategoryInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCommanderPodFilterInput | null > | null,
  or?: Array< ModelCommanderPodFilterInput | null > | null,
  not?: ModelCommanderPodFilterInput | null,
};

export type ModelCommanderPodConnection = {
  __typename: "ModelCommanderPodConnection",
  items:  Array<CommanderPod | null >,
  nextToken?: string | null,
};

export type ModelCommanderPodPlayerFilterInput = {
  id?: ModelIDInput | null,
  eventId?: ModelIDInput | null,
  roundId?: ModelIDInput | null,
  podId?: ModelIDInput | null,
  roundNumber?: ModelIntInput | null,
  userId?: ModelIDInput | null,
  playerConstructId?: ModelIDInput | null,
  registeredCategory?: ModelCommanderCategoryInput | null,
  placement?: ModelIntInput | null,
  points?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCommanderPodPlayerFilterInput | null > | null,
  or?: Array< ModelCommanderPodPlayerFilterInput | null > | null,
  not?: ModelCommanderPodPlayerFilterInput | null,
};

export type ModelCommanderPodPlayerConnection = {
  __typename: "ModelCommanderPodPlayerConnection",
  items:  Array<CommanderPodPlayer | null >,
  nextToken?: string | null,
};

export type ModelEventTopCutResultFilterInput = {
  id?: ModelIDInput | null,
  eventId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  playerConstructId?: ModelIDInput | null,
  rank?: ModelIntInput | null,
  bonusPoints?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelEventTopCutResultFilterInput | null > | null,
  or?: Array< ModelEventTopCutResultFilterInput | null > | null,
  not?: ModelEventTopCutResultFilterInput | null,
};

export type ModelSubscriptionUserFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  username?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  firstName?: ModelSubscriptionStringInput | null,
  lastName?: ModelSubscriptionStringInput | null,
  displayName?: ModelSubscriptionStringInput | null,
  profilePictureUrl?: ModelSubscriptionStringInput | null,
  role?: ModelSubscriptionStringInput | null,
  profileCompleted?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserFilterInput | null > | null,
};

export type ModelSubscriptionIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
};

export type ModelSubscriptionPlayerConstructFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  normalizedName?: ModelSubscriptionStringInput | null,
  totalEvents?: ModelSubscriptionIntInput | null,
  totalPoints?: ModelSubscriptionIntInput | null,
  totalWins?: ModelSubscriptionIntInput | null,
  totalLosses?: ModelSubscriptionIntInput | null,
  totalDraws?: ModelSubscriptionIntInput | null,
  bestRank?: ModelSubscriptionIntInput | null,
  averageRank?: ModelSubscriptionFloatInput | null,
  userId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPlayerConstructFilterInput | null > | null,
  or?: Array< ModelSubscriptionPlayerConstructFilterInput | null > | null,
};

export type ModelSubscriptionIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionLeaguePlayerStatsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  leagueId?: ModelSubscriptionIDInput | null,
  playerConstructId?: ModelSubscriptionIDInput | null,
  totalPoints?: ModelSubscriptionIntInput | null,
  totalEvents?: ModelSubscriptionIntInput | null,
  totalWins?: ModelSubscriptionIntInput | null,
  totalLosses?: ModelSubscriptionIntInput | null,
  totalDraws?: ModelSubscriptionIntInput | null,
  bestRank?: ModelSubscriptionIntInput | null,
  averageRank?: ModelSubscriptionFloatInput | null,
  averageFinishPercentile?: ModelSubscriptionFloatInput | null,
  currentRank?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionLeaguePlayerStatsFilterInput | null > | null,
  or?: Array< ModelSubscriptionLeaguePlayerStatsFilterInput | null > | null,
};

export type ModelSubscriptionLeaguePointAdjustmentFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  leagueId?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  playerConstructId?: ModelSubscriptionIDInput | null,
  playerName?: ModelSubscriptionStringInput | null,
  points?: ModelSubscriptionIntInput | null,
  reason?: ModelSubscriptionStringInput | null,
  createdBy?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionLeaguePointAdjustmentFilterInput | null > | null,
  or?: Array< ModelSubscriptionLeaguePointAdjustmentFilterInput | null > | null,
};

export type ModelSubscriptionEventPlayerResultFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  eventId?: ModelSubscriptionIDInput | null,
  playerConstructId?: ModelSubscriptionIDInput | null,
  rank?: ModelSubscriptionIntInput | null,
  points?: ModelSubscriptionIntInput | null,
  omw?: ModelSubscriptionFloatInput | null,
  gw?: ModelSubscriptionFloatInput | null,
  ogw?: ModelSubscriptionFloatInput | null,
  wins?: ModelSubscriptionIntInput | null,
  losses?: ModelSubscriptionIntInput | null,
  draws?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionEventPlayerResultFilterInput | null > | null,
  or?: Array< ModelSubscriptionEventPlayerResultFilterInput | null > | null,
};

export type ModelSubscriptionLeagueFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  game?: ModelSubscriptionStringInput | null,
  format?: ModelSubscriptionStringInput | null,
  participationPoints?: ModelSubscriptionIntInput | null,
  winPoints?: ModelSubscriptionIntInput | null,
  drawPoints?: ModelSubscriptionIntInput | null,
  lossPoints?: ModelSubscriptionIntInput | null,
  top8FirstPoints?: ModelSubscriptionIntInput | null,
  top8SecondPoints?: ModelSubscriptionIntInput | null,
  top8ThirdFourthPoints?: ModelSubscriptionIntInput | null,
  top8FifthEighthPoints?: ModelSubscriptionIntInput | null,
  commanderFirstPoints?: ModelSubscriptionIntInput | null,
  commanderSecondPoints?: ModelSubscriptionIntInput | null,
  commanderThirdPoints?: ModelSubscriptionIntInput | null,
  commanderFourthPoints?: ModelSubscriptionIntInput | null,
  premiumMultiplier?: ModelSubscriptionIntInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  isActive?: ModelSubscriptionBooleanInput | null,
  maxParticipants?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionLeagueFilterInput | null > | null,
  or?: Array< ModelSubscriptionLeagueFilterInput | null > | null,
};

export type ModelSubscriptionEventFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  leagueId?: ModelSubscriptionIDInput | null,
  date?: ModelSubscriptionStringInput | null,
  location?: ModelSubscriptionStringInput | null,
  format?: ModelSubscriptionStringInput | null,
  maxRounds?: ModelSubscriptionIntInput | null,
  fieldSize?: ModelSubscriptionIntInput | null,
  isCompleted?: ModelSubscriptionBooleanInput | null,
  isPremium?: ModelSubscriptionBooleanInput | null,
  hasTopCut?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionEventFilterInput | null > | null,
  or?: Array< ModelSubscriptionEventFilterInput | null > | null,
};

export type ModelSubscriptionEventParticipantFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  eventId?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  playerConstructId?: ModelSubscriptionIDInput | null,
  commanderCategory?: ModelSubscriptionStringInput | null,
  registrationDate?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionEventParticipantFilterInput | null > | null,
  or?: Array< ModelSubscriptionEventParticipantFilterInput | null > | null,
};

export type ModelSubscriptionEventStandingFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  eventId?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  rank?: ModelSubscriptionIntInput | null,
  points?: ModelSubscriptionIntInput | null,
  omw?: ModelSubscriptionFloatInput | null,
  gw?: ModelSubscriptionFloatInput | null,
  ogw?: ModelSubscriptionFloatInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionEventStandingFilterInput | null > | null,
  or?: Array< ModelSubscriptionEventStandingFilterInput | null > | null,
};

export type ModelSubscriptionMatchFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  eventId?: ModelSubscriptionIDInput | null,
  player1Id?: ModelSubscriptionIDInput | null,
  player2Id?: ModelSubscriptionIDInput | null,
  round?: ModelSubscriptionIntInput | null,
  player1Result?: ModelSubscriptionStringInput | null,
  player2Result?: ModelSubscriptionStringInput | null,
  completedAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionMatchFilterInput | null > | null,
  or?: Array< ModelSubscriptionMatchFilterInput | null > | null,
};

export type ModelSubscriptionCommanderRoundFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  eventId?: ModelSubscriptionIDInput | null,
  roundNumber?: ModelSubscriptionIntInput | null,
  status?: ModelSubscriptionStringInput | null,
  publishedAt?: ModelSubscriptionStringInput | null,
  completedAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionCommanderRoundFilterInput | null > | null,
  or?: Array< ModelSubscriptionCommanderRoundFilterInput | null > | null,
};

export type ModelSubscriptionCommanderPodFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  eventId?: ModelSubscriptionIDInput | null,
  roundId?: ModelSubscriptionIDInput | null,
  roundNumber?: ModelSubscriptionIntInput | null,
  podNumber?: ModelSubscriptionIntInput | null,
  category?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionCommanderPodFilterInput | null > | null,
  or?: Array< ModelSubscriptionCommanderPodFilterInput | null > | null,
};

export type ModelSubscriptionCommanderPodPlayerFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  eventId?: ModelSubscriptionIDInput | null,
  roundId?: ModelSubscriptionIDInput | null,
  podId?: ModelSubscriptionIDInput | null,
  roundNumber?: ModelSubscriptionIntInput | null,
  userId?: ModelSubscriptionIDInput | null,
  playerConstructId?: ModelSubscriptionIDInput | null,
  registeredCategory?: ModelSubscriptionStringInput | null,
  placement?: ModelSubscriptionIntInput | null,
  points?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionCommanderPodPlayerFilterInput | null > | null,
  or?: Array< ModelSubscriptionCommanderPodPlayerFilterInput | null > | null,
};

export type ModelSubscriptionEventTopCutResultFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  eventId?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  playerConstructId?: ModelSubscriptionIDInput | null,
  rank?: ModelSubscriptionIntInput | null,
  bonusPoints?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionEventTopCutResultFilterInput | null > | null,
  or?: Array< ModelSubscriptionEventTopCutResultFilterInput | null > | null,
};

export type CreateUserMutationVariables = {
  input: CreateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type CreateUserMutation = {
  createUser?:  {
    __typename: "User",
    id: string,
    username: string,
    email: string,
    firstName: string,
    lastName: string,
    displayName: string,
    profilePictureUrl?: string | null,
    role: UserRole,
    profileCompleted: boolean,
    playerConstructs?:  {
      __typename: "ModelPlayerConstructConnection",
      nextToken?: string | null,
    } | null,
    topCutResults?:  {
      __typename: "ModelEventTopCutResultConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserMutationVariables = {
  input: UpdateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type UpdateUserMutation = {
  updateUser?:  {
    __typename: "User",
    id: string,
    username: string,
    email: string,
    firstName: string,
    lastName: string,
    displayName: string,
    profilePictureUrl?: string | null,
    role: UserRole,
    profileCompleted: boolean,
    playerConstructs?:  {
      __typename: "ModelPlayerConstructConnection",
      nextToken?: string | null,
    } | null,
    topCutResults?:  {
      __typename: "ModelEventTopCutResultConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserMutationVariables = {
  input: DeleteUserInput,
  condition?: ModelUserConditionInput | null,
};

export type DeleteUserMutation = {
  deleteUser?:  {
    __typename: "User",
    id: string,
    username: string,
    email: string,
    firstName: string,
    lastName: string,
    displayName: string,
    profilePictureUrl?: string | null,
    role: UserRole,
    profileCompleted: boolean,
    playerConstructs?:  {
      __typename: "ModelPlayerConstructConnection",
      nextToken?: string | null,
    } | null,
    topCutResults?:  {
      __typename: "ModelEventTopCutResultConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePlayerConstructMutationVariables = {
  input: CreatePlayerConstructInput,
  condition?: ModelPlayerConstructConditionInput | null,
};

export type CreatePlayerConstructMutation = {
  createPlayerConstruct?:  {
    __typename: "PlayerConstruct",
    id: string,
    name: string,
    normalizedName?: string | null,
    totalEvents: number,
    totalPoints: number,
    totalWins: number,
    totalLosses: number,
    totalDraws: number,
    bestRank?: number | null,
    averageRank?: number | null,
    leagueStats?:  {
      __typename: "ModelLeaguePlayerStatsConnection",
      nextToken?: string | null,
    } | null,
    eventResults?:  {
      __typename: "ModelEventPlayerResultConnection",
      nextToken?: string | null,
    } | null,
    topCutResults?:  {
      __typename: "ModelEventTopCutResultConnection",
      nextToken?: string | null,
    } | null,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      firstName: string,
      lastName: string,
      displayName: string,
      profilePictureUrl?: string | null,
      role: UserRole,
      profileCompleted: boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePlayerConstructMutationVariables = {
  input: UpdatePlayerConstructInput,
  condition?: ModelPlayerConstructConditionInput | null,
};

export type UpdatePlayerConstructMutation = {
  updatePlayerConstruct?:  {
    __typename: "PlayerConstruct",
    id: string,
    name: string,
    normalizedName?: string | null,
    totalEvents: number,
    totalPoints: number,
    totalWins: number,
    totalLosses: number,
    totalDraws: number,
    bestRank?: number | null,
    averageRank?: number | null,
    leagueStats?:  {
      __typename: "ModelLeaguePlayerStatsConnection",
      nextToken?: string | null,
    } | null,
    eventResults?:  {
      __typename: "ModelEventPlayerResultConnection",
      nextToken?: string | null,
    } | null,
    topCutResults?:  {
      __typename: "ModelEventTopCutResultConnection",
      nextToken?: string | null,
    } | null,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      firstName: string,
      lastName: string,
      displayName: string,
      profilePictureUrl?: string | null,
      role: UserRole,
      profileCompleted: boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePlayerConstructMutationVariables = {
  input: DeletePlayerConstructInput,
  condition?: ModelPlayerConstructConditionInput | null,
};

export type DeletePlayerConstructMutation = {
  deletePlayerConstruct?:  {
    __typename: "PlayerConstruct",
    id: string,
    name: string,
    normalizedName?: string | null,
    totalEvents: number,
    totalPoints: number,
    totalWins: number,
    totalLosses: number,
    totalDraws: number,
    bestRank?: number | null,
    averageRank?: number | null,
    leagueStats?:  {
      __typename: "ModelLeaguePlayerStatsConnection",
      nextToken?: string | null,
    } | null,
    eventResults?:  {
      __typename: "ModelEventPlayerResultConnection",
      nextToken?: string | null,
    } | null,
    topCutResults?:  {
      __typename: "ModelEventTopCutResultConnection",
      nextToken?: string | null,
    } | null,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      firstName: string,
      lastName: string,
      displayName: string,
      profilePictureUrl?: string | null,
      role: UserRole,
      profileCompleted: boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLeaguePlayerStatsMutationVariables = {
  input: CreateLeaguePlayerStatsInput,
  condition?: ModelLeaguePlayerStatsConditionInput | null,
};

export type CreateLeaguePlayerStatsMutation = {
  createLeaguePlayerStats?:  {
    __typename: "LeaguePlayerStats",
    id: string,
    leagueId: string,
    league?:  {
      __typename: "League",
      id: string,
      name: string,
      description?: string | null,
      game?: string | null,
      format: string,
      participationPoints?: number | null,
      winPoints?: number | null,
      drawPoints?: number | null,
      lossPoints?: number | null,
      top8FirstPoints?: number | null,
      top8SecondPoints?: number | null,
      top8ThirdFourthPoints?: number | null,
      top8FifthEighthPoints?: number | null,
      commanderFirstPoints?: number | null,
      commanderSecondPoints?: number | null,
      commanderThirdPoints?: number | null,
      commanderFourthPoints?: number | null,
      premiumMultiplier?: number | null,
      startDate: string,
      endDate?: string | null,
      isActive: boolean,
      maxParticipants?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    playerConstructId: string,
    playerConstruct?:  {
      __typename: "PlayerConstruct",
      id: string,
      name: string,
      normalizedName?: string | null,
      totalEvents: number,
      totalPoints: number,
      totalWins: number,
      totalLosses: number,
      totalDraws: number,
      bestRank?: number | null,
      averageRank?: number | null,
      userId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    totalPoints: number,
    totalEvents: number,
    totalWins: number,
    totalLosses: number,
    totalDraws: number,
    bestRank?: number | null,
    averageRank?: number | null,
    averageFinishPercentile?: number | null,
    currentRank?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLeaguePlayerStatsMutationVariables = {
  input: UpdateLeaguePlayerStatsInput,
  condition?: ModelLeaguePlayerStatsConditionInput | null,
};

export type UpdateLeaguePlayerStatsMutation = {
  updateLeaguePlayerStats?:  {
    __typename: "LeaguePlayerStats",
    id: string,
    leagueId: string,
    league?:  {
      __typename: "League",
      id: string,
      name: string,
      description?: string | null,
      game?: string | null,
      format: string,
      participationPoints?: number | null,
      winPoints?: number | null,
      drawPoints?: number | null,
      lossPoints?: number | null,
      top8FirstPoints?: number | null,
      top8SecondPoints?: number | null,
      top8ThirdFourthPoints?: number | null,
      top8FifthEighthPoints?: number | null,
      commanderFirstPoints?: number | null,
      commanderSecondPoints?: number | null,
      commanderThirdPoints?: number | null,
      commanderFourthPoints?: number | null,
      premiumMultiplier?: number | null,
      startDate: string,
      endDate?: string | null,
      isActive: boolean,
      maxParticipants?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    playerConstructId: string,
    playerConstruct?:  {
      __typename: "PlayerConstruct",
      id: string,
      name: string,
      normalizedName?: string | null,
      totalEvents: number,
      totalPoints: number,
      totalWins: number,
      totalLosses: number,
      totalDraws: number,
      bestRank?: number | null,
      averageRank?: number | null,
      userId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    totalPoints: number,
    totalEvents: number,
    totalWins: number,
    totalLosses: number,
    totalDraws: number,
    bestRank?: number | null,
    averageRank?: number | null,
    averageFinishPercentile?: number | null,
    currentRank?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLeaguePlayerStatsMutationVariables = {
  input: DeleteLeaguePlayerStatsInput,
  condition?: ModelLeaguePlayerStatsConditionInput | null,
};

export type DeleteLeaguePlayerStatsMutation = {
  deleteLeaguePlayerStats?:  {
    __typename: "LeaguePlayerStats",
    id: string,
    leagueId: string,
    league?:  {
      __typename: "League",
      id: string,
      name: string,
      description?: string | null,
      game?: string | null,
      format: string,
      participationPoints?: number | null,
      winPoints?: number | null,
      drawPoints?: number | null,
      lossPoints?: number | null,
      top8FirstPoints?: number | null,
      top8SecondPoints?: number | null,
      top8ThirdFourthPoints?: number | null,
      top8FifthEighthPoints?: number | null,
      commanderFirstPoints?: number | null,
      commanderSecondPoints?: number | null,
      commanderThirdPoints?: number | null,
      commanderFourthPoints?: number | null,
      premiumMultiplier?: number | null,
      startDate: string,
      endDate?: string | null,
      isActive: boolean,
      maxParticipants?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    playerConstructId: string,
    playerConstruct?:  {
      __typename: "PlayerConstruct",
      id: string,
      name: string,
      normalizedName?: string | null,
      totalEvents: number,
      totalPoints: number,
      totalWins: number,
      totalLosses: number,
      totalDraws: number,
      bestRank?: number | null,
      averageRank?: number | null,
      userId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    totalPoints: number,
    totalEvents: number,
    totalWins: number,
    totalLosses: number,
    totalDraws: number,
    bestRank?: number | null,
    averageRank?: number | null,
    averageFinishPercentile?: number | null,
    currentRank?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLeaguePointAdjustmentMutationVariables = {
  input: CreateLeaguePointAdjustmentInput,
  condition?: ModelLeaguePointAdjustmentConditionInput | null,
};

export type CreateLeaguePointAdjustmentMutation = {
  createLeaguePointAdjustment?:  {
    __typename: "LeaguePointAdjustment",
    id: string,
    leagueId: string,
    userId?: string | null,
    playerConstructId?: string | null,
    playerName: string,
    points: number,
    reason: string,
    createdBy: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLeaguePointAdjustmentMutationVariables = {
  input: UpdateLeaguePointAdjustmentInput,
  condition?: ModelLeaguePointAdjustmentConditionInput | null,
};

export type UpdateLeaguePointAdjustmentMutation = {
  updateLeaguePointAdjustment?:  {
    __typename: "LeaguePointAdjustment",
    id: string,
    leagueId: string,
    userId?: string | null,
    playerConstructId?: string | null,
    playerName: string,
    points: number,
    reason: string,
    createdBy: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLeaguePointAdjustmentMutationVariables = {
  input: DeleteLeaguePointAdjustmentInput,
  condition?: ModelLeaguePointAdjustmentConditionInput | null,
};

export type DeleteLeaguePointAdjustmentMutation = {
  deleteLeaguePointAdjustment?:  {
    __typename: "LeaguePointAdjustment",
    id: string,
    leagueId: string,
    userId?: string | null,
    playerConstructId?: string | null,
    playerName: string,
    points: number,
    reason: string,
    createdBy: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateEventPlayerResultMutationVariables = {
  input: CreateEventPlayerResultInput,
  condition?: ModelEventPlayerResultConditionInput | null,
};

export type CreateEventPlayerResultMutation = {
  createEventPlayerResult?:  {
    __typename: "EventPlayerResult",
    id: string,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      description?: string | null,
      leagueId: string,
      date: string,
      location: string,
      format: string,
      maxRounds: number,
      fieldSize?: number | null,
      isCompleted: boolean,
      isPremium?: boolean | null,
      hasTopCut?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    playerConstructId: string,
    playerConstruct?:  {
      __typename: "PlayerConstruct",
      id: string,
      name: string,
      normalizedName?: string | null,
      totalEvents: number,
      totalPoints: number,
      totalWins: number,
      totalLosses: number,
      totalDraws: number,
      bestRank?: number | null,
      averageRank?: number | null,
      userId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rank: number,
    points: number,
    omw: number,
    gw: number,
    ogw: number,
    wins: number,
    losses: number,
    draws: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateEventPlayerResultMutationVariables = {
  input: UpdateEventPlayerResultInput,
  condition?: ModelEventPlayerResultConditionInput | null,
};

export type UpdateEventPlayerResultMutation = {
  updateEventPlayerResult?:  {
    __typename: "EventPlayerResult",
    id: string,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      description?: string | null,
      leagueId: string,
      date: string,
      location: string,
      format: string,
      maxRounds: number,
      fieldSize?: number | null,
      isCompleted: boolean,
      isPremium?: boolean | null,
      hasTopCut?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    playerConstructId: string,
    playerConstruct?:  {
      __typename: "PlayerConstruct",
      id: string,
      name: string,
      normalizedName?: string | null,
      totalEvents: number,
      totalPoints: number,
      totalWins: number,
      totalLosses: number,
      totalDraws: number,
      bestRank?: number | null,
      averageRank?: number | null,
      userId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rank: number,
    points: number,
    omw: number,
    gw: number,
    ogw: number,
    wins: number,
    losses: number,
    draws: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteEventPlayerResultMutationVariables = {
  input: DeleteEventPlayerResultInput,
  condition?: ModelEventPlayerResultConditionInput | null,
};

export type DeleteEventPlayerResultMutation = {
  deleteEventPlayerResult?:  {
    __typename: "EventPlayerResult",
    id: string,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      description?: string | null,
      leagueId: string,
      date: string,
      location: string,
      format: string,
      maxRounds: number,
      fieldSize?: number | null,
      isCompleted: boolean,
      isPremium?: boolean | null,
      hasTopCut?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    playerConstructId: string,
    playerConstruct?:  {
      __typename: "PlayerConstruct",
      id: string,
      name: string,
      normalizedName?: string | null,
      totalEvents: number,
      totalPoints: number,
      totalWins: number,
      totalLosses: number,
      totalDraws: number,
      bestRank?: number | null,
      averageRank?: number | null,
      userId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rank: number,
    points: number,
    omw: number,
    gw: number,
    ogw: number,
    wins: number,
    losses: number,
    draws: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLeagueMutationVariables = {
  input: CreateLeagueInput,
  condition?: ModelLeagueConditionInput | null,
};

export type CreateLeagueMutation = {
  createLeague?:  {
    __typename: "League",
    id: string,
    name: string,
    description?: string | null,
    game?: string | null,
    format: string,
    participationPoints?: number | null,
    winPoints?: number | null,
    drawPoints?: number | null,
    lossPoints?: number | null,
    top8FirstPoints?: number | null,
    top8SecondPoints?: number | null,
    top8ThirdFourthPoints?: number | null,
    top8FifthEighthPoints?: number | null,
    commanderFirstPoints?: number | null,
    commanderSecondPoints?: number | null,
    commanderThirdPoints?: number | null,
    commanderFourthPoints?: number | null,
    premiumMultiplier?: number | null,
    startDate: string,
    endDate?: string | null,
    isActive: boolean,
    maxParticipants?: number | null,
    playerStats?:  {
      __typename: "ModelLeaguePlayerStatsConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLeagueMutationVariables = {
  input: UpdateLeagueInput,
  condition?: ModelLeagueConditionInput | null,
};

export type UpdateLeagueMutation = {
  updateLeague?:  {
    __typename: "League",
    id: string,
    name: string,
    description?: string | null,
    game?: string | null,
    format: string,
    participationPoints?: number | null,
    winPoints?: number | null,
    drawPoints?: number | null,
    lossPoints?: number | null,
    top8FirstPoints?: number | null,
    top8SecondPoints?: number | null,
    top8ThirdFourthPoints?: number | null,
    top8FifthEighthPoints?: number | null,
    commanderFirstPoints?: number | null,
    commanderSecondPoints?: number | null,
    commanderThirdPoints?: number | null,
    commanderFourthPoints?: number | null,
    premiumMultiplier?: number | null,
    startDate: string,
    endDate?: string | null,
    isActive: boolean,
    maxParticipants?: number | null,
    playerStats?:  {
      __typename: "ModelLeaguePlayerStatsConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLeagueMutationVariables = {
  input: DeleteLeagueInput,
  condition?: ModelLeagueConditionInput | null,
};

export type DeleteLeagueMutation = {
  deleteLeague?:  {
    __typename: "League",
    id: string,
    name: string,
    description?: string | null,
    game?: string | null,
    format: string,
    participationPoints?: number | null,
    winPoints?: number | null,
    drawPoints?: number | null,
    lossPoints?: number | null,
    top8FirstPoints?: number | null,
    top8SecondPoints?: number | null,
    top8ThirdFourthPoints?: number | null,
    top8FifthEighthPoints?: number | null,
    commanderFirstPoints?: number | null,
    commanderSecondPoints?: number | null,
    commanderThirdPoints?: number | null,
    commanderFourthPoints?: number | null,
    premiumMultiplier?: number | null,
    startDate: string,
    endDate?: string | null,
    isActive: boolean,
    maxParticipants?: number | null,
    playerStats?:  {
      __typename: "ModelLeaguePlayerStatsConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateEventMutationVariables = {
  input: CreateEventInput,
  condition?: ModelEventConditionInput | null,
};

export type CreateEventMutation = {
  createEvent?:  {
    __typename: "Event",
    id: string,
    name: string,
    description?: string | null,
    leagueId: string,
    date: string,
    location: string,
    format: string,
    maxRounds: number,
    fieldSize?: number | null,
    isCompleted: boolean,
    isPremium?: boolean | null,
    hasTopCut?: boolean | null,
    playerResults?:  {
      __typename: "ModelEventPlayerResultConnection",
      nextToken?: string | null,
    } | null,
    topCutResults?:  {
      __typename: "ModelEventTopCutResultConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateEventMutationVariables = {
  input: UpdateEventInput,
  condition?: ModelEventConditionInput | null,
};

export type UpdateEventMutation = {
  updateEvent?:  {
    __typename: "Event",
    id: string,
    name: string,
    description?: string | null,
    leagueId: string,
    date: string,
    location: string,
    format: string,
    maxRounds: number,
    fieldSize?: number | null,
    isCompleted: boolean,
    isPremium?: boolean | null,
    hasTopCut?: boolean | null,
    playerResults?:  {
      __typename: "ModelEventPlayerResultConnection",
      nextToken?: string | null,
    } | null,
    topCutResults?:  {
      __typename: "ModelEventTopCutResultConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteEventMutationVariables = {
  input: DeleteEventInput,
  condition?: ModelEventConditionInput | null,
};

export type DeleteEventMutation = {
  deleteEvent?:  {
    __typename: "Event",
    id: string,
    name: string,
    description?: string | null,
    leagueId: string,
    date: string,
    location: string,
    format: string,
    maxRounds: number,
    fieldSize?: number | null,
    isCompleted: boolean,
    isPremium?: boolean | null,
    hasTopCut?: boolean | null,
    playerResults?:  {
      __typename: "ModelEventPlayerResultConnection",
      nextToken?: string | null,
    } | null,
    topCutResults?:  {
      __typename: "ModelEventTopCutResultConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateEventParticipantMutationVariables = {
  input: CreateEventParticipantInput,
  condition?: ModelEventParticipantConditionInput | null,
};

export type CreateEventParticipantMutation = {
  createEventParticipant?:  {
    __typename: "EventParticipant",
    id: string,
    eventId: string,
    userId?: string | null,
    playerConstructId?: string | null,
    commanderCategory?: CommanderCategory | null,
    registrationDate: string,
    status: ParticipantStatus,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateEventParticipantMutationVariables = {
  input: UpdateEventParticipantInput,
  condition?: ModelEventParticipantConditionInput | null,
};

export type UpdateEventParticipantMutation = {
  updateEventParticipant?:  {
    __typename: "EventParticipant",
    id: string,
    eventId: string,
    userId?: string | null,
    playerConstructId?: string | null,
    commanderCategory?: CommanderCategory | null,
    registrationDate: string,
    status: ParticipantStatus,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteEventParticipantMutationVariables = {
  input: DeleteEventParticipantInput,
  condition?: ModelEventParticipantConditionInput | null,
};

export type DeleteEventParticipantMutation = {
  deleteEventParticipant?:  {
    __typename: "EventParticipant",
    id: string,
    eventId: string,
    userId?: string | null,
    playerConstructId?: string | null,
    commanderCategory?: CommanderCategory | null,
    registrationDate: string,
    status: ParticipantStatus,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateEventStandingMutationVariables = {
  input: CreateEventStandingInput,
  condition?: ModelEventStandingConditionInput | null,
};

export type CreateEventStandingMutation = {
  createEventStanding?:  {
    __typename: "EventStanding",
    id: string,
    eventId: string,
    userId: string,
    rank: number,
    points: number,
    omw: number,
    gw: number,
    ogw: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateEventStandingMutationVariables = {
  input: UpdateEventStandingInput,
  condition?: ModelEventStandingConditionInput | null,
};

export type UpdateEventStandingMutation = {
  updateEventStanding?:  {
    __typename: "EventStanding",
    id: string,
    eventId: string,
    userId: string,
    rank: number,
    points: number,
    omw: number,
    gw: number,
    ogw: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteEventStandingMutationVariables = {
  input: DeleteEventStandingInput,
  condition?: ModelEventStandingConditionInput | null,
};

export type DeleteEventStandingMutation = {
  deleteEventStanding?:  {
    __typename: "EventStanding",
    id: string,
    eventId: string,
    userId: string,
    rank: number,
    points: number,
    omw: number,
    gw: number,
    ogw: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateMatchMutationVariables = {
  input: CreateMatchInput,
  condition?: ModelMatchConditionInput | null,
};

export type CreateMatchMutation = {
  createMatch?:  {
    __typename: "Match",
    id: string,
    eventId: string,
    player1Id: string,
    player2Id: string,
    round: number,
    player1Result: MatchResult,
    player2Result: MatchResult,
    completedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateMatchMutationVariables = {
  input: UpdateMatchInput,
  condition?: ModelMatchConditionInput | null,
};

export type UpdateMatchMutation = {
  updateMatch?:  {
    __typename: "Match",
    id: string,
    eventId: string,
    player1Id: string,
    player2Id: string,
    round: number,
    player1Result: MatchResult,
    player2Result: MatchResult,
    completedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteMatchMutationVariables = {
  input: DeleteMatchInput,
  condition?: ModelMatchConditionInput | null,
};

export type DeleteMatchMutation = {
  deleteMatch?:  {
    __typename: "Match",
    id: string,
    eventId: string,
    player1Id: string,
    player2Id: string,
    round: number,
    player1Result: MatchResult,
    player2Result: MatchResult,
    completedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCommanderRoundMutationVariables = {
  input: CreateCommanderRoundInput,
  condition?: ModelCommanderRoundConditionInput | null,
};

export type CreateCommanderRoundMutation = {
  createCommanderRound?:  {
    __typename: "CommanderRound",
    id: string,
    eventId: string,
    roundNumber: number,
    status: CommanderRoundStatus,
    publishedAt?: string | null,
    completedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCommanderRoundMutationVariables = {
  input: UpdateCommanderRoundInput,
  condition?: ModelCommanderRoundConditionInput | null,
};

export type UpdateCommanderRoundMutation = {
  updateCommanderRound?:  {
    __typename: "CommanderRound",
    id: string,
    eventId: string,
    roundNumber: number,
    status: CommanderRoundStatus,
    publishedAt?: string | null,
    completedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCommanderRoundMutationVariables = {
  input: DeleteCommanderRoundInput,
  condition?: ModelCommanderRoundConditionInput | null,
};

export type DeleteCommanderRoundMutation = {
  deleteCommanderRound?:  {
    __typename: "CommanderRound",
    id: string,
    eventId: string,
    roundNumber: number,
    status: CommanderRoundStatus,
    publishedAt?: string | null,
    completedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCommanderPodMutationVariables = {
  input: CreateCommanderPodInput,
  condition?: ModelCommanderPodConditionInput | null,
};

export type CreateCommanderPodMutation = {
  createCommanderPod?:  {
    __typename: "CommanderPod",
    id: string,
    eventId: string,
    roundId: string,
    roundNumber: number,
    podNumber: number,
    category: CommanderCategory,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCommanderPodMutationVariables = {
  input: UpdateCommanderPodInput,
  condition?: ModelCommanderPodConditionInput | null,
};

export type UpdateCommanderPodMutation = {
  updateCommanderPod?:  {
    __typename: "CommanderPod",
    id: string,
    eventId: string,
    roundId: string,
    roundNumber: number,
    podNumber: number,
    category: CommanderCategory,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCommanderPodMutationVariables = {
  input: DeleteCommanderPodInput,
  condition?: ModelCommanderPodConditionInput | null,
};

export type DeleteCommanderPodMutation = {
  deleteCommanderPod?:  {
    __typename: "CommanderPod",
    id: string,
    eventId: string,
    roundId: string,
    roundNumber: number,
    podNumber: number,
    category: CommanderCategory,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCommanderPodPlayerMutationVariables = {
  input: CreateCommanderPodPlayerInput,
  condition?: ModelCommanderPodPlayerConditionInput | null,
};

export type CreateCommanderPodPlayerMutation = {
  createCommanderPodPlayer?:  {
    __typename: "CommanderPodPlayer",
    id: string,
    eventId: string,
    roundId: string,
    podId: string,
    roundNumber: number,
    userId?: string | null,
    playerConstructId?: string | null,
    registeredCategory: CommanderCategory,
    placement?: number | null,
    points?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCommanderPodPlayerMutationVariables = {
  input: UpdateCommanderPodPlayerInput,
  condition?: ModelCommanderPodPlayerConditionInput | null,
};

export type UpdateCommanderPodPlayerMutation = {
  updateCommanderPodPlayer?:  {
    __typename: "CommanderPodPlayer",
    id: string,
    eventId: string,
    roundId: string,
    podId: string,
    roundNumber: number,
    userId?: string | null,
    playerConstructId?: string | null,
    registeredCategory: CommanderCategory,
    placement?: number | null,
    points?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCommanderPodPlayerMutationVariables = {
  input: DeleteCommanderPodPlayerInput,
  condition?: ModelCommanderPodPlayerConditionInput | null,
};

export type DeleteCommanderPodPlayerMutation = {
  deleteCommanderPodPlayer?:  {
    __typename: "CommanderPodPlayer",
    id: string,
    eventId: string,
    roundId: string,
    podId: string,
    roundNumber: number,
    userId?: string | null,
    playerConstructId?: string | null,
    registeredCategory: CommanderCategory,
    placement?: number | null,
    points?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateEventTopCutResultMutationVariables = {
  input: CreateEventTopCutResultInput,
  condition?: ModelEventTopCutResultConditionInput | null,
};

export type CreateEventTopCutResultMutation = {
  createEventTopCutResult?:  {
    __typename: "EventTopCutResult",
    id: string,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      description?: string | null,
      leagueId: string,
      date: string,
      location: string,
      format: string,
      maxRounds: number,
      fieldSize?: number | null,
      isCompleted: boolean,
      isPremium?: boolean | null,
      hasTopCut?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      firstName: string,
      lastName: string,
      displayName: string,
      profilePictureUrl?: string | null,
      role: UserRole,
      profileCompleted: boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    playerConstructId?: string | null,
    playerConstruct?:  {
      __typename: "PlayerConstruct",
      id: string,
      name: string,
      normalizedName?: string | null,
      totalEvents: number,
      totalPoints: number,
      totalWins: number,
      totalLosses: number,
      totalDraws: number,
      bestRank?: number | null,
      averageRank?: number | null,
      userId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rank: number,
    bonusPoints: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateEventTopCutResultMutationVariables = {
  input: UpdateEventTopCutResultInput,
  condition?: ModelEventTopCutResultConditionInput | null,
};

export type UpdateEventTopCutResultMutation = {
  updateEventTopCutResult?:  {
    __typename: "EventTopCutResult",
    id: string,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      description?: string | null,
      leagueId: string,
      date: string,
      location: string,
      format: string,
      maxRounds: number,
      fieldSize?: number | null,
      isCompleted: boolean,
      isPremium?: boolean | null,
      hasTopCut?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      firstName: string,
      lastName: string,
      displayName: string,
      profilePictureUrl?: string | null,
      role: UserRole,
      profileCompleted: boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    playerConstructId?: string | null,
    playerConstruct?:  {
      __typename: "PlayerConstruct",
      id: string,
      name: string,
      normalizedName?: string | null,
      totalEvents: number,
      totalPoints: number,
      totalWins: number,
      totalLosses: number,
      totalDraws: number,
      bestRank?: number | null,
      averageRank?: number | null,
      userId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rank: number,
    bonusPoints: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteEventTopCutResultMutationVariables = {
  input: DeleteEventTopCutResultInput,
  condition?: ModelEventTopCutResultConditionInput | null,
};

export type DeleteEventTopCutResultMutation = {
  deleteEventTopCutResult?:  {
    __typename: "EventTopCutResult",
    id: string,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      description?: string | null,
      leagueId: string,
      date: string,
      location: string,
      format: string,
      maxRounds: number,
      fieldSize?: number | null,
      isCompleted: boolean,
      isPremium?: boolean | null,
      hasTopCut?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      firstName: string,
      lastName: string,
      displayName: string,
      profilePictureUrl?: string | null,
      role: UserRole,
      profileCompleted: boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    playerConstructId?: string | null,
    playerConstruct?:  {
      __typename: "PlayerConstruct",
      id: string,
      name: string,
      normalizedName?: string | null,
      totalEvents: number,
      totalPoints: number,
      totalWins: number,
      totalLosses: number,
      totalDraws: number,
      bestRank?: number | null,
      averageRank?: number | null,
      userId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rank: number,
    bonusPoints: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type GetUserQueryVariables = {
  id: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "User",
    id: string,
    username: string,
    email: string,
    firstName: string,
    lastName: string,
    displayName: string,
    profilePictureUrl?: string | null,
    role: UserRole,
    profileCompleted: boolean,
    playerConstructs?:  {
      __typename: "ModelPlayerConstructConnection",
      nextToken?: string | null,
    } | null,
    topCutResults?:  {
      __typename: "ModelEventTopCutResultConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUsersQueryVariables = {
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUsersQuery = {
  listUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      firstName: string,
      lastName: string,
      displayName: string,
      profilePictureUrl?: string | null,
      role: UserRole,
      profileCompleted: boolean,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPlayerConstructQueryVariables = {
  id: string,
};

export type GetPlayerConstructQuery = {
  getPlayerConstruct?:  {
    __typename: "PlayerConstruct",
    id: string,
    name: string,
    normalizedName?: string | null,
    totalEvents: number,
    totalPoints: number,
    totalWins: number,
    totalLosses: number,
    totalDraws: number,
    bestRank?: number | null,
    averageRank?: number | null,
    leagueStats?:  {
      __typename: "ModelLeaguePlayerStatsConnection",
      nextToken?: string | null,
    } | null,
    eventResults?:  {
      __typename: "ModelEventPlayerResultConnection",
      nextToken?: string | null,
    } | null,
    topCutResults?:  {
      __typename: "ModelEventTopCutResultConnection",
      nextToken?: string | null,
    } | null,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      firstName: string,
      lastName: string,
      displayName: string,
      profilePictureUrl?: string | null,
      role: UserRole,
      profileCompleted: boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPlayerConstructsQueryVariables = {
  filter?: ModelPlayerConstructFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPlayerConstructsQuery = {
  listPlayerConstructs?:  {
    __typename: "ModelPlayerConstructConnection",
    items:  Array< {
      __typename: "PlayerConstruct",
      id: string,
      name: string,
      normalizedName?: string | null,
      totalEvents: number,
      totalPoints: number,
      totalWins: number,
      totalLosses: number,
      totalDraws: number,
      bestRank?: number | null,
      averageRank?: number | null,
      userId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLeaguePlayerStatsQueryVariables = {
  id: string,
};

export type GetLeaguePlayerStatsQuery = {
  getLeaguePlayerStats?:  {
    __typename: "LeaguePlayerStats",
    id: string,
    leagueId: string,
    league?:  {
      __typename: "League",
      id: string,
      name: string,
      description?: string | null,
      game?: string | null,
      format: string,
      participationPoints?: number | null,
      winPoints?: number | null,
      drawPoints?: number | null,
      lossPoints?: number | null,
      top8FirstPoints?: number | null,
      top8SecondPoints?: number | null,
      top8ThirdFourthPoints?: number | null,
      top8FifthEighthPoints?: number | null,
      commanderFirstPoints?: number | null,
      commanderSecondPoints?: number | null,
      commanderThirdPoints?: number | null,
      commanderFourthPoints?: number | null,
      premiumMultiplier?: number | null,
      startDate: string,
      endDate?: string | null,
      isActive: boolean,
      maxParticipants?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    playerConstructId: string,
    playerConstruct?:  {
      __typename: "PlayerConstruct",
      id: string,
      name: string,
      normalizedName?: string | null,
      totalEvents: number,
      totalPoints: number,
      totalWins: number,
      totalLosses: number,
      totalDraws: number,
      bestRank?: number | null,
      averageRank?: number | null,
      userId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    totalPoints: number,
    totalEvents: number,
    totalWins: number,
    totalLosses: number,
    totalDraws: number,
    bestRank?: number | null,
    averageRank?: number | null,
    averageFinishPercentile?: number | null,
    currentRank?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLeaguePlayerStatsQueryVariables = {
  filter?: ModelLeaguePlayerStatsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLeaguePlayerStatsQuery = {
  listLeaguePlayerStats?:  {
    __typename: "ModelLeaguePlayerStatsConnection",
    items:  Array< {
      __typename: "LeaguePlayerStats",
      id: string,
      leagueId: string,
      playerConstructId: string,
      totalPoints: number,
      totalEvents: number,
      totalWins: number,
      totalLosses: number,
      totalDraws: number,
      bestRank?: number | null,
      averageRank?: number | null,
      averageFinishPercentile?: number | null,
      currentRank?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLeaguePointAdjustmentQueryVariables = {
  id: string,
};

export type GetLeaguePointAdjustmentQuery = {
  getLeaguePointAdjustment?:  {
    __typename: "LeaguePointAdjustment",
    id: string,
    leagueId: string,
    userId?: string | null,
    playerConstructId?: string | null,
    playerName: string,
    points: number,
    reason: string,
    createdBy: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLeaguePointAdjustmentsQueryVariables = {
  filter?: ModelLeaguePointAdjustmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLeaguePointAdjustmentsQuery = {
  listLeaguePointAdjustments?:  {
    __typename: "ModelLeaguePointAdjustmentConnection",
    items:  Array< {
      __typename: "LeaguePointAdjustment",
      id: string,
      leagueId: string,
      userId?: string | null,
      playerConstructId?: string | null,
      playerName: string,
      points: number,
      reason: string,
      createdBy: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetEventPlayerResultQueryVariables = {
  id: string,
};

export type GetEventPlayerResultQuery = {
  getEventPlayerResult?:  {
    __typename: "EventPlayerResult",
    id: string,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      description?: string | null,
      leagueId: string,
      date: string,
      location: string,
      format: string,
      maxRounds: number,
      fieldSize?: number | null,
      isCompleted: boolean,
      isPremium?: boolean | null,
      hasTopCut?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    playerConstructId: string,
    playerConstruct?:  {
      __typename: "PlayerConstruct",
      id: string,
      name: string,
      normalizedName?: string | null,
      totalEvents: number,
      totalPoints: number,
      totalWins: number,
      totalLosses: number,
      totalDraws: number,
      bestRank?: number | null,
      averageRank?: number | null,
      userId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rank: number,
    points: number,
    omw: number,
    gw: number,
    ogw: number,
    wins: number,
    losses: number,
    draws: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListEventPlayerResultsQueryVariables = {
  filter?: ModelEventPlayerResultFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEventPlayerResultsQuery = {
  listEventPlayerResults?:  {
    __typename: "ModelEventPlayerResultConnection",
    items:  Array< {
      __typename: "EventPlayerResult",
      id: string,
      eventId: string,
      playerConstructId: string,
      rank: number,
      points: number,
      omw: number,
      gw: number,
      ogw: number,
      wins: number,
      losses: number,
      draws: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLeagueQueryVariables = {
  id: string,
};

export type GetLeagueQuery = {
  getLeague?:  {
    __typename: "League",
    id: string,
    name: string,
    description?: string | null,
    game?: string | null,
    format: string,
    participationPoints?: number | null,
    winPoints?: number | null,
    drawPoints?: number | null,
    lossPoints?: number | null,
    top8FirstPoints?: number | null,
    top8SecondPoints?: number | null,
    top8ThirdFourthPoints?: number | null,
    top8FifthEighthPoints?: number | null,
    commanderFirstPoints?: number | null,
    commanderSecondPoints?: number | null,
    commanderThirdPoints?: number | null,
    commanderFourthPoints?: number | null,
    premiumMultiplier?: number | null,
    startDate: string,
    endDate?: string | null,
    isActive: boolean,
    maxParticipants?: number | null,
    playerStats?:  {
      __typename: "ModelLeaguePlayerStatsConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLeaguesQueryVariables = {
  filter?: ModelLeagueFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLeaguesQuery = {
  listLeagues?:  {
    __typename: "ModelLeagueConnection",
    items:  Array< {
      __typename: "League",
      id: string,
      name: string,
      description?: string | null,
      game?: string | null,
      format: string,
      participationPoints?: number | null,
      winPoints?: number | null,
      drawPoints?: number | null,
      lossPoints?: number | null,
      top8FirstPoints?: number | null,
      top8SecondPoints?: number | null,
      top8ThirdFourthPoints?: number | null,
      top8FifthEighthPoints?: number | null,
      commanderFirstPoints?: number | null,
      commanderSecondPoints?: number | null,
      commanderThirdPoints?: number | null,
      commanderFourthPoints?: number | null,
      premiumMultiplier?: number | null,
      startDate: string,
      endDate?: string | null,
      isActive: boolean,
      maxParticipants?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetEventQueryVariables = {
  id: string,
};

export type GetEventQuery = {
  getEvent?:  {
    __typename: "Event",
    id: string,
    name: string,
    description?: string | null,
    leagueId: string,
    date: string,
    location: string,
    format: string,
    maxRounds: number,
    fieldSize?: number | null,
    isCompleted: boolean,
    isPremium?: boolean | null,
    hasTopCut?: boolean | null,
    playerResults?:  {
      __typename: "ModelEventPlayerResultConnection",
      nextToken?: string | null,
    } | null,
    topCutResults?:  {
      __typename: "ModelEventTopCutResultConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListEventsQueryVariables = {
  filter?: ModelEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEventsQuery = {
  listEvents?:  {
    __typename: "ModelEventConnection",
    items:  Array< {
      __typename: "Event",
      id: string,
      name: string,
      description?: string | null,
      leagueId: string,
      date: string,
      location: string,
      format: string,
      maxRounds: number,
      fieldSize?: number | null,
      isCompleted: boolean,
      isPremium?: boolean | null,
      hasTopCut?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetEventParticipantQueryVariables = {
  id: string,
};

export type GetEventParticipantQuery = {
  getEventParticipant?:  {
    __typename: "EventParticipant",
    id: string,
    eventId: string,
    userId?: string | null,
    playerConstructId?: string | null,
    commanderCategory?: CommanderCategory | null,
    registrationDate: string,
    status: ParticipantStatus,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListEventParticipantsQueryVariables = {
  filter?: ModelEventParticipantFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEventParticipantsQuery = {
  listEventParticipants?:  {
    __typename: "ModelEventParticipantConnection",
    items:  Array< {
      __typename: "EventParticipant",
      id: string,
      eventId: string,
      userId?: string | null,
      playerConstructId?: string | null,
      commanderCategory?: CommanderCategory | null,
      registrationDate: string,
      status: ParticipantStatus,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetEventStandingQueryVariables = {
  id: string,
};

export type GetEventStandingQuery = {
  getEventStanding?:  {
    __typename: "EventStanding",
    id: string,
    eventId: string,
    userId: string,
    rank: number,
    points: number,
    omw: number,
    gw: number,
    ogw: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListEventStandingsQueryVariables = {
  filter?: ModelEventStandingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEventStandingsQuery = {
  listEventStandings?:  {
    __typename: "ModelEventStandingConnection",
    items:  Array< {
      __typename: "EventStanding",
      id: string,
      eventId: string,
      userId: string,
      rank: number,
      points: number,
      omw: number,
      gw: number,
      ogw: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetMatchQueryVariables = {
  id: string,
};

export type GetMatchQuery = {
  getMatch?:  {
    __typename: "Match",
    id: string,
    eventId: string,
    player1Id: string,
    player2Id: string,
    round: number,
    player1Result: MatchResult,
    player2Result: MatchResult,
    completedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListMatchesQueryVariables = {
  filter?: ModelMatchFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMatchesQuery = {
  listMatches?:  {
    __typename: "ModelMatchConnection",
    items:  Array< {
      __typename: "Match",
      id: string,
      eventId: string,
      player1Id: string,
      player2Id: string,
      round: number,
      player1Result: MatchResult,
      player2Result: MatchResult,
      completedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCommanderRoundQueryVariables = {
  id: string,
};

export type GetCommanderRoundQuery = {
  getCommanderRound?:  {
    __typename: "CommanderRound",
    id: string,
    eventId: string,
    roundNumber: number,
    status: CommanderRoundStatus,
    publishedAt?: string | null,
    completedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCommanderRoundsQueryVariables = {
  filter?: ModelCommanderRoundFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCommanderRoundsQuery = {
  listCommanderRounds?:  {
    __typename: "ModelCommanderRoundConnection",
    items:  Array< {
      __typename: "CommanderRound",
      id: string,
      eventId: string,
      roundNumber: number,
      status: CommanderRoundStatus,
      publishedAt?: string | null,
      completedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCommanderPodQueryVariables = {
  id: string,
};

export type GetCommanderPodQuery = {
  getCommanderPod?:  {
    __typename: "CommanderPod",
    id: string,
    eventId: string,
    roundId: string,
    roundNumber: number,
    podNumber: number,
    category: CommanderCategory,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCommanderPodsQueryVariables = {
  filter?: ModelCommanderPodFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCommanderPodsQuery = {
  listCommanderPods?:  {
    __typename: "ModelCommanderPodConnection",
    items:  Array< {
      __typename: "CommanderPod",
      id: string,
      eventId: string,
      roundId: string,
      roundNumber: number,
      podNumber: number,
      category: CommanderCategory,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCommanderPodPlayerQueryVariables = {
  id: string,
};

export type GetCommanderPodPlayerQuery = {
  getCommanderPodPlayer?:  {
    __typename: "CommanderPodPlayer",
    id: string,
    eventId: string,
    roundId: string,
    podId: string,
    roundNumber: number,
    userId?: string | null,
    playerConstructId?: string | null,
    registeredCategory: CommanderCategory,
    placement?: number | null,
    points?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCommanderPodPlayersQueryVariables = {
  filter?: ModelCommanderPodPlayerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCommanderPodPlayersQuery = {
  listCommanderPodPlayers?:  {
    __typename: "ModelCommanderPodPlayerConnection",
    items:  Array< {
      __typename: "CommanderPodPlayer",
      id: string,
      eventId: string,
      roundId: string,
      podId: string,
      roundNumber: number,
      userId?: string | null,
      playerConstructId?: string | null,
      registeredCategory: CommanderCategory,
      placement?: number | null,
      points?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetEventTopCutResultQueryVariables = {
  id: string,
};

export type GetEventTopCutResultQuery = {
  getEventTopCutResult?:  {
    __typename: "EventTopCutResult",
    id: string,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      description?: string | null,
      leagueId: string,
      date: string,
      location: string,
      format: string,
      maxRounds: number,
      fieldSize?: number | null,
      isCompleted: boolean,
      isPremium?: boolean | null,
      hasTopCut?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      firstName: string,
      lastName: string,
      displayName: string,
      profilePictureUrl?: string | null,
      role: UserRole,
      profileCompleted: boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    playerConstructId?: string | null,
    playerConstruct?:  {
      __typename: "PlayerConstruct",
      id: string,
      name: string,
      normalizedName?: string | null,
      totalEvents: number,
      totalPoints: number,
      totalWins: number,
      totalLosses: number,
      totalDraws: number,
      bestRank?: number | null,
      averageRank?: number | null,
      userId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rank: number,
    bonusPoints: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListEventTopCutResultsQueryVariables = {
  filter?: ModelEventTopCutResultFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEventTopCutResultsQuery = {
  listEventTopCutResults?:  {
    __typename: "ModelEventTopCutResultConnection",
    items:  Array< {
      __typename: "EventTopCutResult",
      id: string,
      eventId: string,
      userId?: string | null,
      playerConstructId?: string | null,
      rank: number,
      bonusPoints: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OnCreateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
};

export type OnCreateUserSubscription = {
  onCreateUser?:  {
    __typename: "User",
    id: string,
    username: string,
    email: string,
    firstName: string,
    lastName: string,
    displayName: string,
    profilePictureUrl?: string | null,
    role: UserRole,
    profileCompleted: boolean,
    playerConstructs?:  {
      __typename: "ModelPlayerConstructConnection",
      nextToken?: string | null,
    } | null,
    topCutResults?:  {
      __typename: "ModelEventTopCutResultConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
};

export type OnUpdateUserSubscription = {
  onUpdateUser?:  {
    __typename: "User",
    id: string,
    username: string,
    email: string,
    firstName: string,
    lastName: string,
    displayName: string,
    profilePictureUrl?: string | null,
    role: UserRole,
    profileCompleted: boolean,
    playerConstructs?:  {
      __typename: "ModelPlayerConstructConnection",
      nextToken?: string | null,
    } | null,
    topCutResults?:  {
      __typename: "ModelEventTopCutResultConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
};

export type OnDeleteUserSubscription = {
  onDeleteUser?:  {
    __typename: "User",
    id: string,
    username: string,
    email: string,
    firstName: string,
    lastName: string,
    displayName: string,
    profilePictureUrl?: string | null,
    role: UserRole,
    profileCompleted: boolean,
    playerConstructs?:  {
      __typename: "ModelPlayerConstructConnection",
      nextToken?: string | null,
    } | null,
    topCutResults?:  {
      __typename: "ModelEventTopCutResultConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePlayerConstructSubscriptionVariables = {
  filter?: ModelSubscriptionPlayerConstructFilterInput | null,
};

export type OnCreatePlayerConstructSubscription = {
  onCreatePlayerConstruct?:  {
    __typename: "PlayerConstruct",
    id: string,
    name: string,
    normalizedName?: string | null,
    totalEvents: number,
    totalPoints: number,
    totalWins: number,
    totalLosses: number,
    totalDraws: number,
    bestRank?: number | null,
    averageRank?: number | null,
    leagueStats?:  {
      __typename: "ModelLeaguePlayerStatsConnection",
      nextToken?: string | null,
    } | null,
    eventResults?:  {
      __typename: "ModelEventPlayerResultConnection",
      nextToken?: string | null,
    } | null,
    topCutResults?:  {
      __typename: "ModelEventTopCutResultConnection",
      nextToken?: string | null,
    } | null,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      firstName: string,
      lastName: string,
      displayName: string,
      profilePictureUrl?: string | null,
      role: UserRole,
      profileCompleted: boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePlayerConstructSubscriptionVariables = {
  filter?: ModelSubscriptionPlayerConstructFilterInput | null,
};

export type OnUpdatePlayerConstructSubscription = {
  onUpdatePlayerConstruct?:  {
    __typename: "PlayerConstruct",
    id: string,
    name: string,
    normalizedName?: string | null,
    totalEvents: number,
    totalPoints: number,
    totalWins: number,
    totalLosses: number,
    totalDraws: number,
    bestRank?: number | null,
    averageRank?: number | null,
    leagueStats?:  {
      __typename: "ModelLeaguePlayerStatsConnection",
      nextToken?: string | null,
    } | null,
    eventResults?:  {
      __typename: "ModelEventPlayerResultConnection",
      nextToken?: string | null,
    } | null,
    topCutResults?:  {
      __typename: "ModelEventTopCutResultConnection",
      nextToken?: string | null,
    } | null,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      firstName: string,
      lastName: string,
      displayName: string,
      profilePictureUrl?: string | null,
      role: UserRole,
      profileCompleted: boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePlayerConstructSubscriptionVariables = {
  filter?: ModelSubscriptionPlayerConstructFilterInput | null,
};

export type OnDeletePlayerConstructSubscription = {
  onDeletePlayerConstruct?:  {
    __typename: "PlayerConstruct",
    id: string,
    name: string,
    normalizedName?: string | null,
    totalEvents: number,
    totalPoints: number,
    totalWins: number,
    totalLosses: number,
    totalDraws: number,
    bestRank?: number | null,
    averageRank?: number | null,
    leagueStats?:  {
      __typename: "ModelLeaguePlayerStatsConnection",
      nextToken?: string | null,
    } | null,
    eventResults?:  {
      __typename: "ModelEventPlayerResultConnection",
      nextToken?: string | null,
    } | null,
    topCutResults?:  {
      __typename: "ModelEventTopCutResultConnection",
      nextToken?: string | null,
    } | null,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      firstName: string,
      lastName: string,
      displayName: string,
      profilePictureUrl?: string | null,
      role: UserRole,
      profileCompleted: boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateLeaguePlayerStatsSubscriptionVariables = {
  filter?: ModelSubscriptionLeaguePlayerStatsFilterInput | null,
};

export type OnCreateLeaguePlayerStatsSubscription = {
  onCreateLeaguePlayerStats?:  {
    __typename: "LeaguePlayerStats",
    id: string,
    leagueId: string,
    league?:  {
      __typename: "League",
      id: string,
      name: string,
      description?: string | null,
      game?: string | null,
      format: string,
      participationPoints?: number | null,
      winPoints?: number | null,
      drawPoints?: number | null,
      lossPoints?: number | null,
      top8FirstPoints?: number | null,
      top8SecondPoints?: number | null,
      top8ThirdFourthPoints?: number | null,
      top8FifthEighthPoints?: number | null,
      commanderFirstPoints?: number | null,
      commanderSecondPoints?: number | null,
      commanderThirdPoints?: number | null,
      commanderFourthPoints?: number | null,
      premiumMultiplier?: number | null,
      startDate: string,
      endDate?: string | null,
      isActive: boolean,
      maxParticipants?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    playerConstructId: string,
    playerConstruct?:  {
      __typename: "PlayerConstruct",
      id: string,
      name: string,
      normalizedName?: string | null,
      totalEvents: number,
      totalPoints: number,
      totalWins: number,
      totalLosses: number,
      totalDraws: number,
      bestRank?: number | null,
      averageRank?: number | null,
      userId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    totalPoints: number,
    totalEvents: number,
    totalWins: number,
    totalLosses: number,
    totalDraws: number,
    bestRank?: number | null,
    averageRank?: number | null,
    averageFinishPercentile?: number | null,
    currentRank?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateLeaguePlayerStatsSubscriptionVariables = {
  filter?: ModelSubscriptionLeaguePlayerStatsFilterInput | null,
};

export type OnUpdateLeaguePlayerStatsSubscription = {
  onUpdateLeaguePlayerStats?:  {
    __typename: "LeaguePlayerStats",
    id: string,
    leagueId: string,
    league?:  {
      __typename: "League",
      id: string,
      name: string,
      description?: string | null,
      game?: string | null,
      format: string,
      participationPoints?: number | null,
      winPoints?: number | null,
      drawPoints?: number | null,
      lossPoints?: number | null,
      top8FirstPoints?: number | null,
      top8SecondPoints?: number | null,
      top8ThirdFourthPoints?: number | null,
      top8FifthEighthPoints?: number | null,
      commanderFirstPoints?: number | null,
      commanderSecondPoints?: number | null,
      commanderThirdPoints?: number | null,
      commanderFourthPoints?: number | null,
      premiumMultiplier?: number | null,
      startDate: string,
      endDate?: string | null,
      isActive: boolean,
      maxParticipants?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    playerConstructId: string,
    playerConstruct?:  {
      __typename: "PlayerConstruct",
      id: string,
      name: string,
      normalizedName?: string | null,
      totalEvents: number,
      totalPoints: number,
      totalWins: number,
      totalLosses: number,
      totalDraws: number,
      bestRank?: number | null,
      averageRank?: number | null,
      userId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    totalPoints: number,
    totalEvents: number,
    totalWins: number,
    totalLosses: number,
    totalDraws: number,
    bestRank?: number | null,
    averageRank?: number | null,
    averageFinishPercentile?: number | null,
    currentRank?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteLeaguePlayerStatsSubscriptionVariables = {
  filter?: ModelSubscriptionLeaguePlayerStatsFilterInput | null,
};

export type OnDeleteLeaguePlayerStatsSubscription = {
  onDeleteLeaguePlayerStats?:  {
    __typename: "LeaguePlayerStats",
    id: string,
    leagueId: string,
    league?:  {
      __typename: "League",
      id: string,
      name: string,
      description?: string | null,
      game?: string | null,
      format: string,
      participationPoints?: number | null,
      winPoints?: number | null,
      drawPoints?: number | null,
      lossPoints?: number | null,
      top8FirstPoints?: number | null,
      top8SecondPoints?: number | null,
      top8ThirdFourthPoints?: number | null,
      top8FifthEighthPoints?: number | null,
      commanderFirstPoints?: number | null,
      commanderSecondPoints?: number | null,
      commanderThirdPoints?: number | null,
      commanderFourthPoints?: number | null,
      premiumMultiplier?: number | null,
      startDate: string,
      endDate?: string | null,
      isActive: boolean,
      maxParticipants?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    playerConstructId: string,
    playerConstruct?:  {
      __typename: "PlayerConstruct",
      id: string,
      name: string,
      normalizedName?: string | null,
      totalEvents: number,
      totalPoints: number,
      totalWins: number,
      totalLosses: number,
      totalDraws: number,
      bestRank?: number | null,
      averageRank?: number | null,
      userId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    totalPoints: number,
    totalEvents: number,
    totalWins: number,
    totalLosses: number,
    totalDraws: number,
    bestRank?: number | null,
    averageRank?: number | null,
    averageFinishPercentile?: number | null,
    currentRank?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateLeaguePointAdjustmentSubscriptionVariables = {
  filter?: ModelSubscriptionLeaguePointAdjustmentFilterInput | null,
};

export type OnCreateLeaguePointAdjustmentSubscription = {
  onCreateLeaguePointAdjustment?:  {
    __typename: "LeaguePointAdjustment",
    id: string,
    leagueId: string,
    userId?: string | null,
    playerConstructId?: string | null,
    playerName: string,
    points: number,
    reason: string,
    createdBy: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateLeaguePointAdjustmentSubscriptionVariables = {
  filter?: ModelSubscriptionLeaguePointAdjustmentFilterInput | null,
};

export type OnUpdateLeaguePointAdjustmentSubscription = {
  onUpdateLeaguePointAdjustment?:  {
    __typename: "LeaguePointAdjustment",
    id: string,
    leagueId: string,
    userId?: string | null,
    playerConstructId?: string | null,
    playerName: string,
    points: number,
    reason: string,
    createdBy: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteLeaguePointAdjustmentSubscriptionVariables = {
  filter?: ModelSubscriptionLeaguePointAdjustmentFilterInput | null,
};

export type OnDeleteLeaguePointAdjustmentSubscription = {
  onDeleteLeaguePointAdjustment?:  {
    __typename: "LeaguePointAdjustment",
    id: string,
    leagueId: string,
    userId?: string | null,
    playerConstructId?: string | null,
    playerName: string,
    points: number,
    reason: string,
    createdBy: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateEventPlayerResultSubscriptionVariables = {
  filter?: ModelSubscriptionEventPlayerResultFilterInput | null,
};

export type OnCreateEventPlayerResultSubscription = {
  onCreateEventPlayerResult?:  {
    __typename: "EventPlayerResult",
    id: string,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      description?: string | null,
      leagueId: string,
      date: string,
      location: string,
      format: string,
      maxRounds: number,
      fieldSize?: number | null,
      isCompleted: boolean,
      isPremium?: boolean | null,
      hasTopCut?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    playerConstructId: string,
    playerConstruct?:  {
      __typename: "PlayerConstruct",
      id: string,
      name: string,
      normalizedName?: string | null,
      totalEvents: number,
      totalPoints: number,
      totalWins: number,
      totalLosses: number,
      totalDraws: number,
      bestRank?: number | null,
      averageRank?: number | null,
      userId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rank: number,
    points: number,
    omw: number,
    gw: number,
    ogw: number,
    wins: number,
    losses: number,
    draws: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateEventPlayerResultSubscriptionVariables = {
  filter?: ModelSubscriptionEventPlayerResultFilterInput | null,
};

export type OnUpdateEventPlayerResultSubscription = {
  onUpdateEventPlayerResult?:  {
    __typename: "EventPlayerResult",
    id: string,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      description?: string | null,
      leagueId: string,
      date: string,
      location: string,
      format: string,
      maxRounds: number,
      fieldSize?: number | null,
      isCompleted: boolean,
      isPremium?: boolean | null,
      hasTopCut?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    playerConstructId: string,
    playerConstruct?:  {
      __typename: "PlayerConstruct",
      id: string,
      name: string,
      normalizedName?: string | null,
      totalEvents: number,
      totalPoints: number,
      totalWins: number,
      totalLosses: number,
      totalDraws: number,
      bestRank?: number | null,
      averageRank?: number | null,
      userId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rank: number,
    points: number,
    omw: number,
    gw: number,
    ogw: number,
    wins: number,
    losses: number,
    draws: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteEventPlayerResultSubscriptionVariables = {
  filter?: ModelSubscriptionEventPlayerResultFilterInput | null,
};

export type OnDeleteEventPlayerResultSubscription = {
  onDeleteEventPlayerResult?:  {
    __typename: "EventPlayerResult",
    id: string,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      description?: string | null,
      leagueId: string,
      date: string,
      location: string,
      format: string,
      maxRounds: number,
      fieldSize?: number | null,
      isCompleted: boolean,
      isPremium?: boolean | null,
      hasTopCut?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    playerConstructId: string,
    playerConstruct?:  {
      __typename: "PlayerConstruct",
      id: string,
      name: string,
      normalizedName?: string | null,
      totalEvents: number,
      totalPoints: number,
      totalWins: number,
      totalLosses: number,
      totalDraws: number,
      bestRank?: number | null,
      averageRank?: number | null,
      userId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rank: number,
    points: number,
    omw: number,
    gw: number,
    ogw: number,
    wins: number,
    losses: number,
    draws: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateLeagueSubscriptionVariables = {
  filter?: ModelSubscriptionLeagueFilterInput | null,
};

export type OnCreateLeagueSubscription = {
  onCreateLeague?:  {
    __typename: "League",
    id: string,
    name: string,
    description?: string | null,
    game?: string | null,
    format: string,
    participationPoints?: number | null,
    winPoints?: number | null,
    drawPoints?: number | null,
    lossPoints?: number | null,
    top8FirstPoints?: number | null,
    top8SecondPoints?: number | null,
    top8ThirdFourthPoints?: number | null,
    top8FifthEighthPoints?: number | null,
    commanderFirstPoints?: number | null,
    commanderSecondPoints?: number | null,
    commanderThirdPoints?: number | null,
    commanderFourthPoints?: number | null,
    premiumMultiplier?: number | null,
    startDate: string,
    endDate?: string | null,
    isActive: boolean,
    maxParticipants?: number | null,
    playerStats?:  {
      __typename: "ModelLeaguePlayerStatsConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateLeagueSubscriptionVariables = {
  filter?: ModelSubscriptionLeagueFilterInput | null,
};

export type OnUpdateLeagueSubscription = {
  onUpdateLeague?:  {
    __typename: "League",
    id: string,
    name: string,
    description?: string | null,
    game?: string | null,
    format: string,
    participationPoints?: number | null,
    winPoints?: number | null,
    drawPoints?: number | null,
    lossPoints?: number | null,
    top8FirstPoints?: number | null,
    top8SecondPoints?: number | null,
    top8ThirdFourthPoints?: number | null,
    top8FifthEighthPoints?: number | null,
    commanderFirstPoints?: number | null,
    commanderSecondPoints?: number | null,
    commanderThirdPoints?: number | null,
    commanderFourthPoints?: number | null,
    premiumMultiplier?: number | null,
    startDate: string,
    endDate?: string | null,
    isActive: boolean,
    maxParticipants?: number | null,
    playerStats?:  {
      __typename: "ModelLeaguePlayerStatsConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteLeagueSubscriptionVariables = {
  filter?: ModelSubscriptionLeagueFilterInput | null,
};

export type OnDeleteLeagueSubscription = {
  onDeleteLeague?:  {
    __typename: "League",
    id: string,
    name: string,
    description?: string | null,
    game?: string | null,
    format: string,
    participationPoints?: number | null,
    winPoints?: number | null,
    drawPoints?: number | null,
    lossPoints?: number | null,
    top8FirstPoints?: number | null,
    top8SecondPoints?: number | null,
    top8ThirdFourthPoints?: number | null,
    top8FifthEighthPoints?: number | null,
    commanderFirstPoints?: number | null,
    commanderSecondPoints?: number | null,
    commanderThirdPoints?: number | null,
    commanderFourthPoints?: number | null,
    premiumMultiplier?: number | null,
    startDate: string,
    endDate?: string | null,
    isActive: boolean,
    maxParticipants?: number | null,
    playerStats?:  {
      __typename: "ModelLeaguePlayerStatsConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateEventSubscriptionVariables = {
  filter?: ModelSubscriptionEventFilterInput | null,
};

export type OnCreateEventSubscription = {
  onCreateEvent?:  {
    __typename: "Event",
    id: string,
    name: string,
    description?: string | null,
    leagueId: string,
    date: string,
    location: string,
    format: string,
    maxRounds: number,
    fieldSize?: number | null,
    isCompleted: boolean,
    isPremium?: boolean | null,
    hasTopCut?: boolean | null,
    playerResults?:  {
      __typename: "ModelEventPlayerResultConnection",
      nextToken?: string | null,
    } | null,
    topCutResults?:  {
      __typename: "ModelEventTopCutResultConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateEventSubscriptionVariables = {
  filter?: ModelSubscriptionEventFilterInput | null,
};

export type OnUpdateEventSubscription = {
  onUpdateEvent?:  {
    __typename: "Event",
    id: string,
    name: string,
    description?: string | null,
    leagueId: string,
    date: string,
    location: string,
    format: string,
    maxRounds: number,
    fieldSize?: number | null,
    isCompleted: boolean,
    isPremium?: boolean | null,
    hasTopCut?: boolean | null,
    playerResults?:  {
      __typename: "ModelEventPlayerResultConnection",
      nextToken?: string | null,
    } | null,
    topCutResults?:  {
      __typename: "ModelEventTopCutResultConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteEventSubscriptionVariables = {
  filter?: ModelSubscriptionEventFilterInput | null,
};

export type OnDeleteEventSubscription = {
  onDeleteEvent?:  {
    __typename: "Event",
    id: string,
    name: string,
    description?: string | null,
    leagueId: string,
    date: string,
    location: string,
    format: string,
    maxRounds: number,
    fieldSize?: number | null,
    isCompleted: boolean,
    isPremium?: boolean | null,
    hasTopCut?: boolean | null,
    playerResults?:  {
      __typename: "ModelEventPlayerResultConnection",
      nextToken?: string | null,
    } | null,
    topCutResults?:  {
      __typename: "ModelEventTopCutResultConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateEventParticipantSubscriptionVariables = {
  filter?: ModelSubscriptionEventParticipantFilterInput | null,
};

export type OnCreateEventParticipantSubscription = {
  onCreateEventParticipant?:  {
    __typename: "EventParticipant",
    id: string,
    eventId: string,
    userId?: string | null,
    playerConstructId?: string | null,
    commanderCategory?: CommanderCategory | null,
    registrationDate: string,
    status: ParticipantStatus,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateEventParticipantSubscriptionVariables = {
  filter?: ModelSubscriptionEventParticipantFilterInput | null,
};

export type OnUpdateEventParticipantSubscription = {
  onUpdateEventParticipant?:  {
    __typename: "EventParticipant",
    id: string,
    eventId: string,
    userId?: string | null,
    playerConstructId?: string | null,
    commanderCategory?: CommanderCategory | null,
    registrationDate: string,
    status: ParticipantStatus,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteEventParticipantSubscriptionVariables = {
  filter?: ModelSubscriptionEventParticipantFilterInput | null,
};

export type OnDeleteEventParticipantSubscription = {
  onDeleteEventParticipant?:  {
    __typename: "EventParticipant",
    id: string,
    eventId: string,
    userId?: string | null,
    playerConstructId?: string | null,
    commanderCategory?: CommanderCategory | null,
    registrationDate: string,
    status: ParticipantStatus,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateEventStandingSubscriptionVariables = {
  filter?: ModelSubscriptionEventStandingFilterInput | null,
};

export type OnCreateEventStandingSubscription = {
  onCreateEventStanding?:  {
    __typename: "EventStanding",
    id: string,
    eventId: string,
    userId: string,
    rank: number,
    points: number,
    omw: number,
    gw: number,
    ogw: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateEventStandingSubscriptionVariables = {
  filter?: ModelSubscriptionEventStandingFilterInput | null,
};

export type OnUpdateEventStandingSubscription = {
  onUpdateEventStanding?:  {
    __typename: "EventStanding",
    id: string,
    eventId: string,
    userId: string,
    rank: number,
    points: number,
    omw: number,
    gw: number,
    ogw: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteEventStandingSubscriptionVariables = {
  filter?: ModelSubscriptionEventStandingFilterInput | null,
};

export type OnDeleteEventStandingSubscription = {
  onDeleteEventStanding?:  {
    __typename: "EventStanding",
    id: string,
    eventId: string,
    userId: string,
    rank: number,
    points: number,
    omw: number,
    gw: number,
    ogw: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateMatchSubscriptionVariables = {
  filter?: ModelSubscriptionMatchFilterInput | null,
};

export type OnCreateMatchSubscription = {
  onCreateMatch?:  {
    __typename: "Match",
    id: string,
    eventId: string,
    player1Id: string,
    player2Id: string,
    round: number,
    player1Result: MatchResult,
    player2Result: MatchResult,
    completedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateMatchSubscriptionVariables = {
  filter?: ModelSubscriptionMatchFilterInput | null,
};

export type OnUpdateMatchSubscription = {
  onUpdateMatch?:  {
    __typename: "Match",
    id: string,
    eventId: string,
    player1Id: string,
    player2Id: string,
    round: number,
    player1Result: MatchResult,
    player2Result: MatchResult,
    completedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteMatchSubscriptionVariables = {
  filter?: ModelSubscriptionMatchFilterInput | null,
};

export type OnDeleteMatchSubscription = {
  onDeleteMatch?:  {
    __typename: "Match",
    id: string,
    eventId: string,
    player1Id: string,
    player2Id: string,
    round: number,
    player1Result: MatchResult,
    player2Result: MatchResult,
    completedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateCommanderRoundSubscriptionVariables = {
  filter?: ModelSubscriptionCommanderRoundFilterInput | null,
};

export type OnCreateCommanderRoundSubscription = {
  onCreateCommanderRound?:  {
    __typename: "CommanderRound",
    id: string,
    eventId: string,
    roundNumber: number,
    status: CommanderRoundStatus,
    publishedAt?: string | null,
    completedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateCommanderRoundSubscriptionVariables = {
  filter?: ModelSubscriptionCommanderRoundFilterInput | null,
};

export type OnUpdateCommanderRoundSubscription = {
  onUpdateCommanderRound?:  {
    __typename: "CommanderRound",
    id: string,
    eventId: string,
    roundNumber: number,
    status: CommanderRoundStatus,
    publishedAt?: string | null,
    completedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteCommanderRoundSubscriptionVariables = {
  filter?: ModelSubscriptionCommanderRoundFilterInput | null,
};

export type OnDeleteCommanderRoundSubscription = {
  onDeleteCommanderRound?:  {
    __typename: "CommanderRound",
    id: string,
    eventId: string,
    roundNumber: number,
    status: CommanderRoundStatus,
    publishedAt?: string | null,
    completedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateCommanderPodSubscriptionVariables = {
  filter?: ModelSubscriptionCommanderPodFilterInput | null,
};

export type OnCreateCommanderPodSubscription = {
  onCreateCommanderPod?:  {
    __typename: "CommanderPod",
    id: string,
    eventId: string,
    roundId: string,
    roundNumber: number,
    podNumber: number,
    category: CommanderCategory,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateCommanderPodSubscriptionVariables = {
  filter?: ModelSubscriptionCommanderPodFilterInput | null,
};

export type OnUpdateCommanderPodSubscription = {
  onUpdateCommanderPod?:  {
    __typename: "CommanderPod",
    id: string,
    eventId: string,
    roundId: string,
    roundNumber: number,
    podNumber: number,
    category: CommanderCategory,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteCommanderPodSubscriptionVariables = {
  filter?: ModelSubscriptionCommanderPodFilterInput | null,
};

export type OnDeleteCommanderPodSubscription = {
  onDeleteCommanderPod?:  {
    __typename: "CommanderPod",
    id: string,
    eventId: string,
    roundId: string,
    roundNumber: number,
    podNumber: number,
    category: CommanderCategory,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateCommanderPodPlayerSubscriptionVariables = {
  filter?: ModelSubscriptionCommanderPodPlayerFilterInput | null,
};

export type OnCreateCommanderPodPlayerSubscription = {
  onCreateCommanderPodPlayer?:  {
    __typename: "CommanderPodPlayer",
    id: string,
    eventId: string,
    roundId: string,
    podId: string,
    roundNumber: number,
    userId?: string | null,
    playerConstructId?: string | null,
    registeredCategory: CommanderCategory,
    placement?: number | null,
    points?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateCommanderPodPlayerSubscriptionVariables = {
  filter?: ModelSubscriptionCommanderPodPlayerFilterInput | null,
};

export type OnUpdateCommanderPodPlayerSubscription = {
  onUpdateCommanderPodPlayer?:  {
    __typename: "CommanderPodPlayer",
    id: string,
    eventId: string,
    roundId: string,
    podId: string,
    roundNumber: number,
    userId?: string | null,
    playerConstructId?: string | null,
    registeredCategory: CommanderCategory,
    placement?: number | null,
    points?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteCommanderPodPlayerSubscriptionVariables = {
  filter?: ModelSubscriptionCommanderPodPlayerFilterInput | null,
};

export type OnDeleteCommanderPodPlayerSubscription = {
  onDeleteCommanderPodPlayer?:  {
    __typename: "CommanderPodPlayer",
    id: string,
    eventId: string,
    roundId: string,
    podId: string,
    roundNumber: number,
    userId?: string | null,
    playerConstructId?: string | null,
    registeredCategory: CommanderCategory,
    placement?: number | null,
    points?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateEventTopCutResultSubscriptionVariables = {
  filter?: ModelSubscriptionEventTopCutResultFilterInput | null,
};

export type OnCreateEventTopCutResultSubscription = {
  onCreateEventTopCutResult?:  {
    __typename: "EventTopCutResult",
    id: string,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      description?: string | null,
      leagueId: string,
      date: string,
      location: string,
      format: string,
      maxRounds: number,
      fieldSize?: number | null,
      isCompleted: boolean,
      isPremium?: boolean | null,
      hasTopCut?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      firstName: string,
      lastName: string,
      displayName: string,
      profilePictureUrl?: string | null,
      role: UserRole,
      profileCompleted: boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    playerConstructId?: string | null,
    playerConstruct?:  {
      __typename: "PlayerConstruct",
      id: string,
      name: string,
      normalizedName?: string | null,
      totalEvents: number,
      totalPoints: number,
      totalWins: number,
      totalLosses: number,
      totalDraws: number,
      bestRank?: number | null,
      averageRank?: number | null,
      userId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rank: number,
    bonusPoints: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateEventTopCutResultSubscriptionVariables = {
  filter?: ModelSubscriptionEventTopCutResultFilterInput | null,
};

export type OnUpdateEventTopCutResultSubscription = {
  onUpdateEventTopCutResult?:  {
    __typename: "EventTopCutResult",
    id: string,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      description?: string | null,
      leagueId: string,
      date: string,
      location: string,
      format: string,
      maxRounds: number,
      fieldSize?: number | null,
      isCompleted: boolean,
      isPremium?: boolean | null,
      hasTopCut?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      firstName: string,
      lastName: string,
      displayName: string,
      profilePictureUrl?: string | null,
      role: UserRole,
      profileCompleted: boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    playerConstructId?: string | null,
    playerConstruct?:  {
      __typename: "PlayerConstruct",
      id: string,
      name: string,
      normalizedName?: string | null,
      totalEvents: number,
      totalPoints: number,
      totalWins: number,
      totalLosses: number,
      totalDraws: number,
      bestRank?: number | null,
      averageRank?: number | null,
      userId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rank: number,
    bonusPoints: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteEventTopCutResultSubscriptionVariables = {
  filter?: ModelSubscriptionEventTopCutResultFilterInput | null,
};

export type OnDeleteEventTopCutResultSubscription = {
  onDeleteEventTopCutResult?:  {
    __typename: "EventTopCutResult",
    id: string,
    eventId: string,
    event?:  {
      __typename: "Event",
      id: string,
      name: string,
      description?: string | null,
      leagueId: string,
      date: string,
      location: string,
      format: string,
      maxRounds: number,
      fieldSize?: number | null,
      isCompleted: boolean,
      isPremium?: boolean | null,
      hasTopCut?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      username: string,
      email: string,
      firstName: string,
      lastName: string,
      displayName: string,
      profilePictureUrl?: string | null,
      role: UserRole,
      profileCompleted: boolean,
      createdAt: string,
      updatedAt: string,
    } | null,
    playerConstructId?: string | null,
    playerConstruct?:  {
      __typename: "PlayerConstruct",
      id: string,
      name: string,
      normalizedName?: string | null,
      totalEvents: number,
      totalPoints: number,
      totalWins: number,
      totalLosses: number,
      totalDraws: number,
      bestRank?: number | null,
      averageRank?: number | null,
      userId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rank: number,
    bonusPoints: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};
